export const suggest = [
    {"id": 0, "name": "Akimiski Island"},
        {"id": 1, "name": "Alaska"},
        {"id": 2, "name": "Alexandra Fiord"},
        {"id": 3, "name": "Amundsen Gulf"},
        {"id": 4, "name": "Anaktalak Bay"},
        {"id": 5, "name": "Antarctic"},
        {"id": 6, "name": "Apex River"},
        {"id": 7, "name": "Arctic"},
        {"id": 8, "name": "Arctic Ocean"},
        {"id": 9, "name": "Asia"},
        {"id": 10, "name": "Aulavik"},
        {"id": 11, "name": "Auyuittuq"},
        {"id": 12, "name": "Axel Heiberg Island"},
        {"id": 13, "name": "Ayles Fiord"},
        {"id": 14, "name": "Ayles Ice Shelf"},
        {"id": 15, "name": "Aylmer Lake"},
        {"id": 16, "name": "Back River"},
        {"id": 17, "name": "Baffin Bay"},
        {"id": 18, "name": "Baffin Island"},
        {"id": 19, "name": "Banks Island"},
        {"id": 20, "name": "Barents Sea"},
        {"id": 21, "name": "Barrow Strait"},
        {"id": 22, "name": "Bathurst Island"},
        {"id": 23, "name": "Beaufort Sea"},
        {"id": 24, "name": "Boreal"},
        {"id": 25, "name": "Bylot Island"},
        {"id": 26, "name": "Canada"},
        {"id": 27, "name": "Canadian Arctic Archipelago"},
        {"id": 28, "name": "Canadian High Arctic"},
        {"id": 29, "name": "Cape Bounty"},
        {"id": 30, "name": "Cape Churchill"},
        {"id": 31, "name": "Char Lake"},
        {"id": 32, "name": "Chukchi Sea"},
        {"id": 33, "name": "Churchill River"},
        {"id": 34, "name": "Circumpolar region"},
        {"id": 35, "name": "Cornwallis Island"},
        {"id": 36, "name": "Creswell Bay"},
        {"id": 37, "name": "Cumberland Sound"},
        {"id": 38, "name": "Daneborg"},
        {"id": 39, "name": "Daring Lake"},
        {"id": 40, "name": "Davis Strait"},
        {"id": 41, "name": "Devon Island"},
        {"id": 42, "name": "Disraeli Fiord"},
        {"id": 43, "name": "Drayton Island"},
        {"id": 44, "name": "East Bay"},
        {"id": 45, "name": "Eastwind Lake"},
        {"id": 46, "name": "Eclipse Sound"},
        {"id": 47, "name": "Ellef Ringnes Island"},
        {"id": 48, "name": "Ellesmere Island"},
        {"id": 49, "name": "Eureka Sound"},
        {"id": 50, "name": "Europe"},
        {"id": 51, "name": "Finland"},
        {"id": 52, "name": "Fosheim Peninsula"},
        {"id": 53, "name": "Foxe Basin"},
        {"id": 54, "name": "Franklin Bay"},
        {"id": 55, "name": "Frobisher Bay"},
        {"id": 56, "name": "Fungal endophytes"},
        {"id": 57, "name": "Funk Island"},
        {"id": 58, "name": "Gladstone Lakes"},
        {"id": 59, "name": "Global"},
        {"id": 60, "name": "Goose Bay"},
        {"id": 61, "name": "Goose River"},
        {"id": 62, "name": "Grand Banks"},
        {"id": 63, "name": "Grand Lake"},
        {"id": 64, "name": "Great Lakes"},
        {"id": 65, "name": "Greenland"},
        {"id": 66, "name": "Greiner Lake"},
        {"id": 67, "name": "Griffith Island"},
        {"id": 68, "name": "Gulf of St. Lawrence"},
        {"id": 69, "name": "Herschel Island"},
        {"id": 70, "name": "Himalaya"},
        {"id": 71, "name": "Horanaday River"},
        {"id": 72, "name": "Hudson Bay"},
        {"id": 73, "name": "Hudson Strait"},
        {"id": 74, "name": "Iceland"},
        {"id": 75, "name": "Inuit Nunangat"},
        {"id": 76, "name": "Inuvialuit"},
        {"id": 77, "name": "Ivvavik"},
        {"id": 78, "name": "James Bay"},
        {"id": 79, "name": "Jones Sound"},
        {"id": 80, "name": "Kangirsualujjuaq"},
        {"id": 81, "name": "Kangirsujuaq"},
        {"id": 82, "name": "Kara Sea"},
        {"id": 83, "name": "Kazan River"},
        {"id": 84, "name": "Kent Peninsula"},
        {"id": 85, "name": "Kivalliq"},
        {"id": 86, "name": "Kluane"},
        {"id": 87, "name": "Kluane national park"},
        {"id": 88, "name": "Komakuk Beach"},
        {"id": 89, "name": "Kosoak"},
        {"id": 90, "name": "La Grande Basin"},
        {"id": 91, "name": "La Perouse Bay"},
        {"id": 92, "name": "Labrador"},
        {"id": 93, "name": "Labrador Sea"},
        {"id": 94, "name": "Lac à l'Eau Claire"},
        {"id": 95, "name": "Lake A"},
        {"id": 96, "name": "Lake Amituk"},
        {"id": 97, "name": "Lake Erie"},
        {"id": 98, "name": "Lake Hazen"},
        {"id": 99, "name": "Lake Huron"},
        {"id": 100, "name": "Lake Melville"},
        {"id": 101, "name": "Lake Ontario"},
        {"id": 102, "name": "Lake Resolute"},
        {"id": 103, "name": "Lake Superior"},
        {"id": 104, "name": "Lancaster Sound"},
        {"id": 105, "name": "Lapland"},
        {"id": 106, "name": "Laptev Sea"},
        {"id": 107, "name": "Lena River"},
        {"id": 108, "name": "Lowther Island"},
        {"id": 109, "name": "Mackenzie Mountains"},
        {"id": 110, "name": "Mackenzie River"},
        {"id": 111, "name": "Mackenzie Shelf"},
        {"id": 112, "name": "Makkovik Bay"},
        {"id": 113, "name": "Manitoba"},
        {"id": 114, "name": "Markham Fiord"},
        {"id": 115, "name": "Markham Ice Shelf"},
        {"id": 116, "name": "Meadowbank River"},
        {"id": 117, "name": "Meliadine River"},
        {"id": 118, "name": "Melville Island"},
        {"id": 119, "name": "Melville Peninsula"},
        {"id": 120, "name": "Milne Ice Shelf"},
        {"id": 121, "name": "Nachvak Fiord"},
        {"id": 122, "name": "Nahanni"},
        {"id": 123, "name": "Nares Strait"},
        {"id": 124, "name": "Nepihjee River"},
        {"id": 125, "name": "Newfoundland"},
        {"id": 126, "name": "Newfoundland Shelf"},
        {"id": 127, "name": "Niaqunguk River"},
        {"id": 128, "name": "North America"},
        {"id": 129, "name": "North Pole"},
        {"id": 130, "name": "North Water Polynya"},
        {"id": 131, "name": "Northern Canada"},
        {"id": 132, "name": "Northern Hemisphere"},
        {"id": 133, "name": "Northwest Atlantic Ocean"},
        {"id": 134, "name": "Northwest Passage"},
        {"id": 135, "name": "Northwest Territories"},
        {"id": 136, "name": "Norway"},
        {"id": 137, "name": "Nunatsiavut"},
        {"id": 138, "name": "Nunavik"},
        {"id": 139, "name": "Nunavut"},
        {"id": 140, "name": "Nuuk"},
        {"id": 141, "name": "Okak Bay"},
        {"id": 142, "name": "Old Factory River"},
        {"id": 143, "name": "Oliver Sound"},
        {"id": 144, "name": "Ontario"},
        {"id": 145, "name": "Pechora River"},
        {"id": 146, "name": "Pechora Sea"},
        {"id": 147, "name": "Petermann Glacier"},
        {"id": 148, "name": "Pingualuit"},
        {"id": 149, "name": "Polaris Mine"},
        {"id": 150, "name": "Postglacial Tyrrell Sea"},
        {"id": 151, "name": "Prince of Wales Icefield"},
        {"id": 152, "name": "Queen Elizabeth Islands"},
        {"id": 153, "name": "Quttinirpaaq"},
        {"id": 154, "name": "Quttinirpaaq national park"},
        {"id": 155, "name": "Québec"},
        {"id": 156, "name": "Rambow Bay"},
        {"id": 157, "name": "Resolute Bay"},
        {"id": 158, "name": "Russia"},
        {"id": 159, "name": "Russian Federation"},
        {"id": 160, "name": "Saglek Bay"},
        {"id": 161, "name": "Saskatchewan"},
        {"id": 162, "name": "Sewage treatment"},
        {"id": 163, "name": "Siberian Arctic"},
        {"id": 164, "name": "Sirmilik"},
        {"id": 165, "name": "Southampton Island"},
        {"id": 166, "name": "St. Helena Island"},
        {"id": 167, "name": "Subantarctic"},
        {"id": 168, "name": "Subarctic"},
        {"id": 169, "name": "Subarctique"},
        {"id": 170, "name": "Svalbard"},
        {"id": 171, "name": "Sverdrup Pass"},
        {"id": 172, "name": "Sweden"},
        {"id": 173, "name": "Taimyr Peninsula"},
        {"id": 174, "name": "Tanquary Fiord"},
        {"id": 175, "name": "Tatshenshini-Alsek Park"},
        {"id": 176, "name": "Tehek Lake"},
        {"id": 177, "name": "Thelon River"},
        {"id": 178, "name": "Torngat Mountains"},
        {"id": 179, "name": "Tuktoyaktuk Peninsula"},
        {"id": 180, "name": "Tuktut Nogait"},
        {"id": 181, "name": "Ukkusuksalik"},
        {"id": 182, "name": "Ungava Bay"},
        {"id": 183, "name": "Ungava Peninsula"},
        {"id": 184, "name": "Victoria Island"},
        {"id": 185, "name": "Viscount Melville Sound"},
        {"id": 186, "name": "Voisey's Bay"},
        {"id": 187, "name": "Vuntut"},
        {"id": 188, "name": "Wadham Islands"},
        {"id": 189, "name": "Walker Bay"},
        {"id": 190, "name": "Wapusk"},
        {"id": 191, "name": "Ward Hunt Ice Shelf"},
        {"id": 192, "name": "Ward Hunt Island"},
        {"id": 193, "name": "Ward Hunt Lake"},
        {"id": 194, "name": "White Sea"},
        {"id": 195, "name": "Yukon"},
        {"id": 196, "name": "Altitude"},
        {"id": 197, "name": "Anions"},
        {"id": 198, "name": "Anisakidae"},
        {"id": 199, "name": "Antibodies"},
        {"id": 200, "name": "Atherosclerosis"},
        {"id": 201, "name": "Atmospheric elemental mercury"},
        {"id": 202, "name": "Bioaccumulation"},
        {"id": 203, "name": "Blizzards"},
        {"id": 204, "name": "Blood lipids"},
        {"id": 205, "name": "Blood pressure"},
        {"id": 206, "name": "Blood samples"},
        {"id": 207, "name": "Blowing snow"},
        {"id": 208, "name": "Brominated diphenyl ethers"},
        {"id": 209, "name": "Brucella"},
        {"id": 210, "name": "Brucellosis"},
        {"id": 211, "name": "Cadmium"},
        {"id": 212, "name": "Campylobacter"},
        {"id": 213, "name": "Cancer"},
        {"id": 214, "name": "Cardiovascular risk factors"},
        {"id": 215, "name": "Cerebellum"},
        {"id": 216, "name": "Children"},
        {"id": 217, "name": "Chronology"},
        {"id": 218, "name": "Clostridium"},
        {"id": 219, "name": "Community health"},
        {"id": 220, "name": "Coxiella"},
        {"id": 221, "name": "Cryptosporidium"},
        {"id": 222, "name": "Cumulative effects"},
        {"id": 223, "name": "Current use pesticide"},
        {"id": 224, "name": "Cushion plants"},
        {"id": 225, "name": "Database (contaminants)"},
        {"id": 226, "name": "Database (health)"},
        {"id": 227, "name": "DDT"},
        {"id": 228, "name": "Desulfovibrio"},
        {"id": 229, "name": "Development"},
        {"id": 230, "name": "Diagenesis"},
        {"id": 231, "name": "Diagnostic methods"},
        {"id": 232, "name": "Diet"},
        {"id": 233, "name": "Digestion assay"},
        {"id": 234, "name": "Dimethylmercury"},
        {"id": 235, "name": "Disease"},
        {"id": 236, "name": "Dissolved gaseous mercury"},
        {"id": 237, "name": "Distribution (Contaminants)"},
        {"id": 238, "name": "E. coli"},
        {"id": 239, "name": "Echinicoccus"},
        {"id": 240, "name": "Echinococcosis"},
        {"id": 241, "name": "Ecophysiology"},
        {"id": 242, "name": "Ecotoxicology"},
        {"id": 243, "name": "Enterococcus"},
        {"id": 244, "name": "Enzyme"},
        {"id": 245, "name": "F-specific coliphages"},
        {"id": 246, "name": "Food consumption"},
        {"id": 247, "name": "Francisella"},
        {"id": 248, "name": "Freshwater availability"},
        {"id": 249, "name": "Freshwater quality"},
        {"id": 250, "name": "Gastroenteritis"},
        {"id": 251, "name": "Giardia"},
        {"id": 252, "name": "Greenhouse gases"},
        {"id": 253, "name": "Halogenated phenolics"},
        {"id": 254, "name": "Health"},
        {"id": 255, "name": "Health communication"},
        {"id": 256, "name": "Health risk"},
        {"id": 257, "name": "Health status"},
        {"id": 258, "name": "Health survey"},
        {"id": 259, "name": "Hearing disorders"},
        {"id": 260, "name": "Heart disease"},
        {"id": 261, "name": "Heavy metal"},
        {"id": 262, "name": "Hepatitis B"},
        {"id": 263, "name": "Herbicides"},
        {"id": 264, "name": "Hospital archives"},
        {"id": 265, "name": "HPCs"},
        {"id": 266, "name": "Human Papillomavirus"},
        {"id": 267, "name": "Hydatid disease"},
        {"id": 268, "name": "Hydrocarbon"},
        {"id": 269, "name": "Hydroxylated metabolites"},
        {"id": 270, "name": "Hypothermia"},
        {"id": 271, "name": "Inuit Health Survey"},
        {"id": 272, "name": "Inuit lifestyles"},
        {"id": 273, "name": "Junk food"},
        {"id": 274, "name": "Lake varve"},
        {"id": 275, "name": "Legacy pesticide"},
        {"id": 276, "name": "Leptospira"},
        {"id": 277, "name": "Leptospirosis"},
        {"id": 278, "name": "Lifestyle"},
        {"id": 279, "name": "Light"},
        {"id": 280, "name": "Lipid"},
        {"id": 281, "name": "Liver cirrhosis"},
        {"id": 282, "name": "Maternity care"},
        {"id": 283, "name": "MDE"},
        {"id": 284, "name": "Medical authorities"},
        {"id": 285, "name": "Mental health"},
        {"id": 286, "name": "Mercury"},
        {"id": 287, "name": "Mercury depletion events"},
        {"id": 288, "name": "Mercury speciation"},
        {"id": 289, "name": "Methylmercury"},
        {"id": 290, "name": "Microbial community"},
        {"id": 291, "name": "Midwife"},
        {"id": 292, "name": "Mollusc"},
        {"id": 293, "name": "Multiple chronologies"},
        {"id": 294, "name": "Neurotoxin"},
        {"id": 295, "name": "Norovirus"},
        {"id": 296, "name": "Nunavik Public Health Direction"},
        {"id": 297, "name": "Nutrition"},
        {"id": 298, "name": "Obesity"},
        {"id": 299, "name": "Organophosphate flame retardants"},
        {"id": 300, "name": "Organophosphate plasticizers"},
        {"id": 301, "name": "Oxygen isotopic analysis"},
        {"id": 302, "name": "Parasite"},
        {"id": 303, "name": "Past climate reconstruction"},
        {"id": 304, "name": "Pathogen"},
        {"id": 305, "name": "PCBs"},
        {"id": 306, "name": "PCR (polymerase chain reaction)"},
        {"id": 307, "name": "Perfluorinated acids"},
        {"id": 308, "name": "Perfluorinated alkylated substances"},
        {"id": 309, "name": "Perfluoro contaminant"},
        {"id": 310, "name": "Perfluorooctanesulfonate"},
        {"id": 311, "name": "Perfluorooctanoate"},
        {"id": 312, "name": "Perinatal exposure"},
        {"id": 313, "name": "Persistent organic pollutants (POPs)"},
        {"id": 314, "name": "Photochemistry"},
        {"id": 315, "name": "Photodegradation"},
        {"id": 316, "name": "Pneumonia"},
        {"id": 317, "name": "Pregnancy"},
        {"id": 318, "name": "Productivity"},
        {"id": 319, "name": "Propylthiouracil"},
        {"id": 320, "name": "Public health"},
        {"id": 321, "name": "Q fever"},
        {"id": 322, "name": "Questionnaire"},
        {"id": 323, "name": "Rabies"},
        {"id": 324, "name": "Reactive bromide oxide"},
        {"id": 325, "name": "Reproduction"},
        {"id": 326, "name": "Respiratory infections"},
        {"id": 327, "name": "Risk factor"},
        {"id": 328, "name": "Safety"},
        {"id": 329, "name": "Salmonella"},
        {"id": 330, "name": "Sanitation"},
        {"id": 331, "name": "Seal meat"},
        {"id": 332, "name": "Serology"},
        {"id": 333, "name": "Seroprevalence"},
        {"id": 334, "name": "Shelter"},
        {"id": 335, "name": "Shigella"},
        {"id": 336, "name": "Streptococcus"},
        {"id": 337, "name": "Subsistence"},
        {"id": 338, "name": "Surveillance"},
        {"id": 339, "name": "Total gaseous mercury"},
        {"id": 340, "name": "Toxocara"},
        {"id": 341, "name": "Toxocariasis"},
        {"id": 342, "name": "Toxoplasma gondii"},
        {"id": 343, "name": "Toxoplasmosis"},
        {"id": 344, "name": "Trace elements"},
        {"id": 345, "name": "Traditional diet"},
        {"id": 346, "name": "Traditional food"},
        {"id": 347, "name": "Trail"},
        {"id": 348, "name": "Trans fats"},
        {"id": 349, "name": "Trends"},
        {"id": 350, "name": "Trichinella"},
        {"id": 351, "name": "Tularemia"},
        {"id": 352, "name": "Vaccination programs"},
        {"id": 353, "name": "Vaccines"},
        {"id": 354, "name": "Water quality"},
        {"id": 355, "name": "Wind chill"},
        {"id": 356, "name": "Yersina"},
        {"id": 357, "name": "Zoonosis"},
        {"id": 358, "name": "Inuit Qaujimajatuqangit"},
        {"id": 359, "name": "Isumagijaksaq"},
        {"id": 360, "name": "Qaujisarvik"},
        {"id": 361, "name": "Sila"},
        {"id": 362, "name": "Unikkaaqatigiit"},
        {"id": 363, "name": "Time-Lapse Photos"},
        {"id": 364, "name": "137-Cs"},
        {"id": 365, "name": "210-Pb"},
        {"id": 366, "name": "AboVE"},
        {"id": 367, "name": "Absorbance"},
        {"id": 368, "name": "Abundance"},
        {"id": 369, "name": "Acoustic"},
        {"id": 370, "name": "Active layer"},
        {"id": 371, "name": "Activity"},
        {"id": 372, "name": "Aerial photographs"},
        {"id": 373, "name": "Aerial surveys"},
        {"id": 374, "name": "Ahiak caribou herd"},
        {"id": 375, "name": "Air"},
        {"id": 376, "name": "Air gas exchange"},
        {"id": 377, "name": "Air temperature"},
        {"id": 378, "name": "Air-water exchange"},
        {"id": 379, "name": "Akia-Maniitsoq caribou herd"},
        {"id": 380, "name": "Albedo"},
        {"id": 381, "name": "Algae"},
        {"id": 382, "name": "Algal bloom"},
        {"id": 383, "name": "Alien species"},
        {"id": 384, "name": "Alkalinity"},
        {"id": 385, "name": "Allochthonous organic matter"},
        {"id": 386, "name": "Alpine"},
        {"id": 387, "name": "American crow"},
        {"id": 388, "name": "Amphibians"},
        {"id": 389, "name": "Anadromous"},
        {"id": 390, "name": "Archaea"},
        {"id": 391, "name": "Arctic char"},
        {"id": 392, "name": "Arctic cod"},
        {"id": 393, "name": "Arctic fox"},
        {"id": 394, "name": "Arctic gull"},
        {"id": 395, "name": "Arctic Oscillation"},
        {"id": 396, "name": "Arctic wolf"},
        {"id": 397, "name": "Arthropods"},
        {"id": 398, "name": "Atmosphere"},
        {"id": 399, "name": "Atmospheric composition"},
        {"id": 400, "name": "Atmospheric profiler"},
        {"id": 401, "name": "Autochthonous organic matter"},
        {"id": 402, "name": "Backscatter"},
        {"id": 403, "name": "Bacteria"},
        {"id": 404, "name": "Bacterial production"},
        {"id": 405, "name": "Bacterivory"},
        {"id": 406, "name": "Barometric pressure"},
        {"id": 407, "name": "Baseline data"},
        {"id": 408, "name": "Bathurst caribou herd"},
        {"id": 409, "name": "Bathymetry"},
        {"id": 410, "name": "Beavers"},
        {"id": 411, "name": "Bedrock"},
        {"id": 412, "name": "Bees"},
        {"id": 413, "name": "Beetles"},
        {"id": 414, "name": "Beluga"},
        {"id": 415, "name": "Benthic surveys"},
        {"id": 416, "name": "Benthos"},
        {"id": 417, "name": "Berries"},
        {"id": 418, "name": "Berry productivity"},
        {"id": 419, "name": "Beverly caribou herd"},
        {"id": 420, "name": "Biodiversity"},
        {"id": 421, "name": "Biogeochemistry"},
        {"id": 422, "name": "Biological productivity"},
        {"id": 423, "name": "Biological sciences"},
        {"id": 424, "name": "Biology"},
        {"id": 425, "name": "Biomarkers"},
        {"id": 426, "name": "Biomass"},
        {"id": 427, "name": "Biota"},
        {"id": 428, "name": "Birch (Betula)"},
        {"id": 429, "name": "Bird banding"},
        {"id": 430, "name": "Bird colonies"},
        {"id": 431, "name": "Birds"},
        {"id": 432, "name": "Bivalves"},
        {"id": 433, "name": "Bluenose East caribou herd"},
        {"id": 434, "name": "Bluenose West caribou herd"},
        {"id": 435, "name": "Body condition"},
        {"id": 436, "name": "Bottom sediments"},
        {"id": 437, "name": "Bouleau (Betula)"},
        {"id": 438, "name": "Bowhead whale"},
        {"id": 439, "name": "Breeding"},
        {"id": 440, "name": "Breeding colonies"},
        {"id": 441, "name": "Breeding ecology"},
        {"id": 442, "name": "Brightness temperature"},
        {"id": 443, "name": "Brine"},
        {"id": 444, "name": "Bromide"},
        {"id": 445, "name": "Bromine oxide"},
        {"id": 446, "name": "Brown lemming"},
        {"id": 447, "name": "Bryophytes"},
        {"id": 448, "name": "Buoys"},
        {"id": 449, "name": "Cackling Geese"},
        {"id": 450, "name": "Calving"},
        {"id": 451, "name": "Canada goose"},
        {"id": 452, "name": "Cape Bathurst caribou herd"},
        {"id": 453, "name": "Carbon"},
        {"id": 454, "name": "Carbon dioxide"},
        {"id": 455, "name": "Carbon fluxes"},
        {"id": 456, "name": "Carbon lability"},
        {"id": 457, "name": "Carbon, nitrogen and sulfur analysis (CNS)"},
        {"id": 458, "name": "Carbonate"},
        {"id": 459, "name": "Caribou"},
        {"id": 460, "name": "Caribou demography"},
        {"id": 461, "name": "Carnivores"},
        {"id": 462, "name": "CAT scan"},
        {"id": 463, "name": "Central Arctic caribou herd"},
        {"id": 464, "name": "Changements climatiques"},
        {"id": 465, "name": "Char"},
        {"id": 466, "name": "Characteristic transport distance"},
        {"id": 467, "name": "Chart"},
        {"id": 468, "name": "Chemistry"},
        {"id": 469, "name": "Chironomids"},
        {"id": 470, "name": "Chloride"},
        {"id": 471, "name": "Chlorophyll"},
        {"id": 472, "name": "Chokotka caribou herd"},
        {"id": 473, "name": "Cicatrices de piétinement"},
        {"id": 474, "name": "Circulation"},
        {"id": 475, "name": "Cladocera"},
        {"id": 476, "name": "Clay"},
        {"id": 477, "name": "Climate"},
        {"id": 478, "name": "Climate change"},
        {"id": 479, "name": "Climate hazards"},
        {"id": 480, "name": "Climate history"},
        {"id": 481, "name": "Climatic models"},
        {"id": 482, "name": "Climatology"},
        {"id": 483, "name": "Clone library"},
        {"id": 484, "name": "Cloudbase height"},
        {"id": 485, "name": "Clouds"},
        {"id": 486, "name": "Coastal dynamics"},
        {"id": 487, "name": "Coastal erosion"},
        {"id": 488, "name": "Coastal hazards"},
        {"id": 489, "name": "Coastal ice"},
        {"id": 490, "name": "Coastline"},
        {"id": 491, "name": "Cod"},
        {"id": 492, "name": "Cold Regions Hydrological Model (CRHM)"},
        {"id": 493, "name": "Collared lemming"},
        {"id": 494, "name": "Collembola"},
        {"id": 495, "name": "Colored dissolved organic material (CDOM)"},
        {"id": 496, "name": "Common eider"},
        {"id": 497, "name": "Common murre"},
        {"id": 498, "name": "Common raven"},
        {"id": 499, "name": "Community ecology"},
        {"id": 500, "name": "Community-based monitoring"},
        {"id": 501, "name": "Conduction"},
        {"id": 502, "name": "Conductivity"},
        {"id": 503, "name": "Conifers"},
        {"id": 504, "name": "Contaminants"},
        {"id": 505, "name": "Convection"},
        {"id": 506, "name": "Copepods"},
        {"id": 507, "name": "Corals"},
        {"id": 508, "name": "Couvert nival"},
        {"id": 509, "name": "Crab"},
        {"id": 510, "name": "Croissance arbustive"},
        {"id": 511, "name": "Crustaceans"},
        {"id": 512, "name": "Cryosphere"},
        {"id": 513, "name": "CTD (Conductivity, Temperature, Depth)"},
        {"id": 514, "name": "CTD profiles"},
        {"id": 515, "name": "Cyanobacteria"},
        {"id": 516, "name": "Daphnia"},
        {"id": 517, "name": "Database"},
        {"id": 518, "name": "Decomposition"},
        {"id": 519, "name": "Deep water"},
        {"id": 520, "name": "Deer"},
        {"id": 521, "name": "Deglaciation"},
        {"id": 522, "name": "Delta"},
        {"id": 523, "name": "Dendrochronologie"},
        {"id": 524, "name": "Dendrochronology"},
        {"id": 525, "name": "Density"},
        {"id": 526, "name": "Dewpoint"},
        {"id": 527, "name": "Diatoms"},
        {"id": 528, "name": "Dielectric"},
        {"id": 529, "name": "Diesel"},
        {"id": 530, "name": "Dimethylsulfide (DMS)"},
        {"id": 531, "name": "Dimethylsulfoniopropionate (DMSP)"},
        {"id": 532, "name": "Dinoflagellate cyst"},
        {"id": 533, "name": "Dinoflagellates"},
        {"id": 534, "name": "Diptera"},
        {"id": 535, "name": "Direction finder"},
        {"id": 536, "name": "Discontinuous permafrost"},
        {"id": 537, "name": "Dissolved inorganic carbon (DIC)"},
        {"id": 538, "name": "Dissolved organic carbon (DOC)"},
        {"id": 539, "name": "Dissolved organic matter (DOM)"},
        {"id": 540, "name": "Distribution"},
        {"id": 541, "name": "Disturbance"},
        {"id": 542, "name": "Diversity"},
        {"id": 543, "name": "DNA"},
        {"id": 544, "name": "Drainage basin"},
        {"id": 545, "name": "Drinking water"},
        {"id": 546, "name": "Dry upland heath"},
        {"id": 547, "name": "Décomposition"},
        {"id": 548, "name": "Earth Sciences"},
        {"id": 549, "name": "Eastern High Arctic Brant"},
        {"id": 550, "name": "Ecology"},
        {"id": 551, "name": "Ecosystem"},
        {"id": 552, "name": "Ecosystem functions"},
        {"id": 553, "name": "Ecosystem services"},
        {"id": 554, "name": "Ecotype"},
        {"id": 555, "name": "Eddy covariance"},
        {"id": 556, "name": "Eiders"},
        {"id": 557, "name": "El Niño"},
        {"id": 558, "name": "Elevation Change"},
        {"id": 559, "name": "Emissions"},
        {"id": 560, "name": "Emmission Excitation Matrices (EEMs)"},
        {"id": 561, "name": "Empetrum nigrum"},
        {"id": 562, "name": "Energy balance"},
        {"id": 563, "name": "Environmental impacts"},
        {"id": 564, "name": "ENVISAT"},
        {"id": 565, "name": "Epiphytes"},
        {"id": 566, "name": "Epishelf lakes"},
        {"id": 567, "name": "Ermine"},
        {"id": 568, "name": "Erosion"},
        {"id": 569, "name": "Estuary"},
        {"id": 570, "name": "Eukaryotes"},
        {"id": 571, "name": "Eutrophication"},
        {"id": 572, "name": "Experimental warming"},
        {"id": 573, "name": "Export production"},
        {"id": 574, "name": "Extracellular enzymes"},
        {"id": 575, "name": "Extracellular polymeric substances"},
        {"id": 576, "name": "Extreme habitats"},
        {"id": 577, "name": "Extreme weather"},
        {"id": 578, "name": "Extremophiles"},
        {"id": 579, "name": "Fatty acids"},
        {"id": 580, "name": "Fauna"},
        {"id": 581, "name": "Fecundity"},
        {"id": 582, "name": "Feeding"},
        {"id": 583, "name": "Feeding experiment"},
        {"id": 584, "name": "Feeding success"},
        {"id": 585, "name": "Femtoplankton"},
        {"id": 586, "name": "Fiords"},
        {"id": 587, "name": "Fire"},
        {"id": 588, "name": "Fish larvae"},
        {"id": 589, "name": "Fisheries"},
        {"id": 590, "name": "Fishes"},
        {"id": 591, "name": "Fitness"},
        {"id": 592, "name": "Flies"},
        {"id": 593, "name": "Flood"},
        {"id": 594, "name": "Flora"},
        {"id": 595, "name": "Flowering plants"},
        {"id": 596, "name": "Flowers"},
        {"id": 597, "name": "Fluorescence"},
        {"id": 598, "name": "Fluorinated contaminants"},
        {"id": 599, "name": "Fluvial"},
        {"id": 600, "name": "Flux"},
        {"id": 601, "name": "Fluxes"},
        {"id": 602, "name": "Food"},
        {"id": 603, "name": "Food web"},
        {"id": 604, "name": "Foraminifers"},
        {"id": 605, "name": "Forecast"},
        {"id": 606, "name": "Forest-tundra"},
        {"id": 607, "name": "Forests"},
        {"id": 608, "name": "Fossils"},
        {"id": 609, "name": "Foxes"},
        {"id": 610, "name": "Freeze-up"},
        {"id": 611, "name": "Frequency"},
        {"id": 612, "name": "Freshwater flows"},
        {"id": 613, "name": "Freshwater fluxes"},
        {"id": 614, "name": "Freshwaters"},
        {"id": 615, "name": "Frogs"},
        {"id": 616, "name": "Frost flowers"},
        {"id": 617, "name": "Fulmars"},
        {"id": 618, "name": "Fungi"},
        {"id": 619, "name": "Gases"},
        {"id": 620, "name": "Gastropod"},
        {"id": 621, "name": "Geese"},
        {"id": 622, "name": "General Circulation Model"},
        {"id": 623, "name": "Genetic analysis"},
        {"id": 624, "name": "Geodetic"},
        {"id": 625, "name": "Geohazard"},
        {"id": 626, "name": "Geology"},
        {"id": 627, "name": "Geomorphology"},
        {"id": 628, "name": "Geophysical surveys"},
        {"id": 629, "name": "George River caribou herd"},
        {"id": 630, "name": "Geospatial data"},
        {"id": 631, "name": "GIS"},
        {"id": 632, "name": "Glacial runoff"},
        {"id": 633, "name": "Glaciers"},
        {"id": 634, "name": "Glaciology"},
        {"id": 635, "name": "Glaucous gull"},
        {"id": 636, "name": "Goose"},
        {"id": 637, "name": "GPS"},
        {"id": 638, "name": "Gradients"},
        {"id": 639, "name": "Grain size"},
        {"id": 640, "name": "Graines"},
        {"id": 641, "name": "Graminoids"},
        {"id": 642, "name": "Grass"},
        {"id": 643, "name": "Gravity processes"},
        {"id": 644, "name": "Grazing"},
        {"id": 645, "name": "Grazing impacts"},
        {"id": 646, "name": "Greater snow geese"},
        {"id": 647, "name": "Greenhouse gas"},
        {"id": 648, "name": "Greenland shark"},
        {"id": 649, "name": "Grizzly bear"},
        {"id": 650, "name": "Ground ice"},
        {"id": 651, "name": "Ground penetrating radar"},
        {"id": 652, "name": "Ground surveys"},
        {"id": 653, "name": "Ground temperature"},
        {"id": 654, "name": "Groundwater"},
        {"id": 655, "name": "Grouse"},
        {"id": 656, "name": "Growth rate"},
        {"id": 657, "name": "Guillemots"},
        {"id": 658, "name": "Gull"},
        {"id": 659, "name": "Gulls"},
        {"id": 660, "name": "Gut content analyses"},
        {"id": 661, "name": "Habitat use"},
        {"id": 662, "name": "Habitats"},
        {"id": 663, "name": "Halibuts"},
        {"id": 664, "name": "Hardangaarvida caribou herd"},
        {"id": 665, "name": "Hares"},
        {"id": 666, "name": "Heat"},
        {"id": 667, "name": "Heat budget"},
        {"id": 668, "name": "Heat fluxes"},
        {"id": 669, "name": "Herbivores"},
        {"id": 670, "name": "Herbivory"},
        {"id": 671, "name": "Herring gull"},
        {"id": 672, "name": "Heterotrophy"},
        {"id": 673, "name": "Holocene"},
        {"id": 674, "name": "Horizontal gene transfer"},
        {"id": 675, "name": "Humidity"},
        {"id": 676, "name": "Hydrochemistry"},
        {"id": 677, "name": "Hydroelectric reservoir"},
        {"id": 678, "name": "Hydroelectricity"},
        {"id": 679, "name": "Hydrography"},
        {"id": 680, "name": "Hydrology"},
        {"id": 681, "name": "Ice"},
        {"id": 682, "name": "Ice algae"},
        {"id": 683, "name": "Ice break-up"},
        {"id": 684, "name": "Ice chart"},
        {"id": 685, "name": "Ice cores"},
        {"id": 686, "name": "Ice drift"},
        {"id": 687, "name": "Ice island"},
        {"id": 688, "name": "Ice margin"},
        {"id": 689, "name": "Ice microstructure"},
        {"id": 690, "name": "Ice pack motion"},
        {"id": 691, "name": "Ice patch"},
        {"id": 692, "name": "Ice shelf"},
        {"id": 693, "name": "Ice thickness"},
        {"id": 694, "name": "Ice wedges"},
        {"id": 695, "name": "Iceberg"},
        {"id": 696, "name": "Iceland caribou herd"},
        {"id": 697, "name": "Ichthyoplankton"},
        {"id": 698, "name": "Ikonos"},
        {"id": 699, "name": "Image analysis"},
        {"id": 700, "name": "Imagery"},
        {"id": 701, "name": "Images"},
        {"id": 702, "name": "Indicators"},
        {"id": 703, "name": "Infrared"},
        {"id": 704, "name": "Infrastructures"},
        {"id": 705, "name": "Ingestion rates"},
        {"id": 706, "name": "Insects"},
        {"id": 707, "name": "Integrated Regional Impact Studies"},
        {"id": 708, "name": "Inter-specific relationships"},
        {"id": 709, "name": "Interflow"},
        {"id": 710, "name": "Invasive species"},
        {"id": 711, "name": "Invertebrates"},
        {"id": 712, "name": "Ions concentration"},
        {"id": 713, "name": "Isotopes"},
        {"id": 714, "name": "ITRAX"},
        {"id": 715, "name": "Jaegers"},
        {"id": 716, "name": "JPEG"},
        {"id": 717, "name": "Kangerlussuaq-Sisimiut caribou herd"},
        {"id": 718, "name": "Kemmerer water sampler"},
        {"id": 719, "name": "Keystone species"},
        {"id": 720, "name": "Killer whale"},
        {"id": 721, "name": "Lake"},
        {"id": 722, "name": "Lake ice"},
        {"id": 723, "name": "Lake sediments"},
        {"id": 724, "name": "Lake trout"},
        {"id": 725, "name": "Lake water turbidity"},
        {"id": 726, "name": "Lakes"},
        {"id": 727, "name": "Land cover"},
        {"id": 728, "name": "Land Surface Temperature"},
        {"id": 729, "name": "Land-water interface"},
        {"id": 730, "name": "Landfast ice"},
        {"id": 731, "name": "Landform"},
        {"id": 732, "name": "Landsat image"},
        {"id": 733, "name": "Landscape"},
        {"id": 734, "name": "Landslide"},
        {"id": 735, "name": "Lapland longspur"},
        {"id": 736, "name": "Larval fishes"},
        {"id": 737, "name": "Laser"},
        {"id": 738, "name": "Leads"},
        {"id": 739, "name": "Leaf River caribou herd"},
        {"id": 740, "name": "Lemmings"},
        {"id": 741, "name": "Lena-Olenyk caribou herd"},
        {"id": 742, "name": "Lepidoptera"},
        {"id": 743, "name": "Lesser snow geese"},
        {"id": 744, "name": "Lichens"},
        {"id": 745, "name": "LiDAR"},
        {"id": 746, "name": "Life history"},
        {"id": 747, "name": "Lignin"},
        {"id": 748, "name": "Limite des arbres"},
        {"id": 749, "name": "Limnology"},
        {"id": 750, "name": "Liquid chromatography"},
        {"id": 751, "name": "Litter size"},
        {"id": 752, "name": "Long-tailed jaeger"},
        {"id": 753, "name": "Loons"},
        {"id": 754, "name": "Loss on ignition (LOI)"},
        {"id": 755, "name": "Lungworm"},
        {"id": 756, "name": "Macrophytes"},
        {"id": 757, "name": "Macrozoobenthos"},
        {"id": 758, "name": "Malaise traps"},
        {"id": 759, "name": "Mammals"},
        {"id": 760, "name": "Map layers"},
        {"id": 761, "name": "Mapping"},
        {"id": 762, "name": "Maps"},
        {"id": 763, "name": "Marine birds"},
        {"id": 764, "name": "Marine ecology"},
        {"id": 765, "name": "Marine mammals"},
        {"id": 766, "name": "Marine productivity"},
        {"id": 767, "name": "Marine sediments"},
        {"id": 768, "name": "Mass Balance"},
        {"id": 769, "name": "Mass movements"},
        {"id": 770, "name": "Mass spectrometry"},
        {"id": 771, "name": "Megazoobenthos"},
        {"id": 772, "name": "Meltpond"},
        {"id": 773, "name": "Meltpond fraction"},
        {"id": 774, "name": "Mercury fluxes"},
        {"id": 775, "name": "Mesic tundra"},
        {"id": 776, "name": "Metadata"},
        {"id": 777, "name": "Metals"},
        {"id": 778, "name": "Meteorological"},
        {"id": 779, "name": "Meteorology"},
        {"id": 780, "name": "Methane"},
        {"id": 781, "name": "Methanesulphonate"},
        {"id": 782, "name": "Microarray"},
        {"id": 783, "name": "Microbial food webs"},
        {"id": 784, "name": "Microbial methylation"},
        {"id": 785, "name": "Microfossils"},
        {"id": 786, "name": "Microorganisms"},
        {"id": 787, "name": "Microplastics"},
        {"id": 788, "name": "Microwave"},
        {"id": 789, "name": "Microzooplankton"},
        {"id": 790, "name": "Migration"},
        {"id": 791, "name": "Migratory routes"},
        {"id": 792, "name": "Mineralogy"},
        {"id": 793, "name": "Mines"},
        {"id": 794, "name": "MOBS"},
        {"id": 795, "name": "Modeling"},
        {"id": 796, "name": "Models"},
        {"id": 797, "name": "MODIS"},
        {"id": 798, "name": "Molecular biogeochemistry"},
        {"id": 799, "name": "Molluscs"},
        {"id": 800, "name": "Momentum fluxes"},
        {"id": 801, "name": "Monitoring"},
        {"id": 802, "name": "Mooring"},
        {"id": 803, "name": "Moose"},
        {"id": 804, "name": "Morphology"},
        {"id": 805, "name": "Mosquitos"},
        {"id": 806, "name": "Moss"},
        {"id": 807, "name": "Motion"},
        {"id": 808, "name": "Movement"},
        {"id": 809, "name": "Multibeam"},
        {"id": 810, "name": "Murres"},
        {"id": 811, "name": "Muskoxen"},
        {"id": 812, "name": "Mussels"},
        {"id": 813, "name": "Nanoflagellates"},
        {"id": 814, "name": "Narwhals"},
        {"id": 815, "name": "NASA"},
        {"id": 816, "name": "Natural radionuclides"},
        {"id": 817, "name": "Nepheloid layer"},
        {"id": 818, "name": "Nesting"},
        {"id": 819, "name": "New production"},
        {"id": 820, "name": "Nitrates"},
        {"id": 821, "name": "Nitrogen"},
        {"id": 822, "name": "Nitrous oxide (N2O)"},
        {"id": 823, "name": "Nuclear magnetic resonance"},
        {"id": 824, "name": "Nutrient availability"},
        {"id": 825, "name": "Nutrient cycling"},
        {"id": 826, "name": "Nutrient inputs"},
        {"id": 827, "name": "Nutrients"},
        {"id": 828, "name": "Observatory"},
        {"id": 829, "name": "Ocean acidification"},
        {"id": 830, "name": "Ocean circulation"},
        {"id": 831, "name": "Ocean currents"},
        {"id": 832, "name": "Oceanic water masses"},
        {"id": 833, "name": "Oceanography"},
        {"id": 834, "name": "Oceans"},
        {"id": 835, "name": "Omnitrax"},
        {"id": 836, "name": "Optical"},
        {"id": 837, "name": "Optics"},
        {"id": 838, "name": "Organic carbon"},
        {"id": 839, "name": "Organic matter"},
        {"id": 840, "name": "Organic microfossils"},
        {"id": 841, "name": "Organohalogens"},
        {"id": 842, "name": "Ostracods"},
        {"id": 843, "name": "Otolith"},
        {"id": 844, "name": "Otoliths"},
        {"id": 845, "name": "Ouranos"},
        {"id": 846, "name": "Outbreak"},
        {"id": 847, "name": "Overflow"},
        {"id": 848, "name": "Oxygen"},
        {"id": 849, "name": "Oxygen isotopes"},
        {"id": 850, "name": "Ozone"},
        {"id": 851, "name": "Paleo-indicators"},
        {"id": 852, "name": "Paleoceanography"},
        {"id": 853, "name": "Paleoclimate"},
        {"id": 854, "name": "Paleoclimatic reconstruction"},
        {"id": 855, "name": "Paleoecology"},
        {"id": 856, "name": "Paleoenvironment"},
        {"id": 857, "name": "Paleolimnology"},
        {"id": 858, "name": "Paleomagnetism"},
        {"id": 859, "name": "Palsa"},
        {"id": 860, "name": "Parasites"},
        {"id": 861, "name": "Parasitic jaeger"},
        {"id": 862, "name": "Particles"},
        {"id": 863, "name": "Particulate inorganic carbon"},
        {"id": 864, "name": "Particulate organic carbon"},
        {"id": 865, "name": "Passerines"},
        {"id": 866, "name": "Passive microwave"},
        {"id": 867, "name": "Pathfinder"},
        {"id": 868, "name": "Peary caribou"},
        {"id": 869, "name": "Peat"},
        {"id": 870, "name": "Peat cores"},
        {"id": 871, "name": "Peat cover"},
        {"id": 872, "name": "Peatland"},
        {"id": 873, "name": "Peregrine falcon"},
        {"id": 874, "name": "Perennial ice"},
        {"id": 875, "name": "Periphyton"},
        {"id": 876, "name": "Permafrost"},
        {"id": 877, "name": "Pesticides"},
        {"id": 878, "name": "pH"},
        {"id": 879, "name": "Phenology"},
        {"id": 880, "name": "Phosphorus"},
        {"id": 881, "name": "Photo-oxidation"},
        {"id": 882, "name": "Photoprotection"},
        {"id": 883, "name": "Photosynthesis"},
        {"id": 884, "name": "Photosynthetically available radiation (PAR)"},
        {"id": 885, "name": "Physical forcing"},
        {"id": 886, "name": "Physical-biological coupling"},
        {"id": 887, "name": "Phytoplankton"},
        {"id": 888, "name": "Phytoplankton viability"},
        {"id": 889, "name": "Picea glauca"},
        {"id": 890, "name": "Picocyanobacteria"},
        {"id": 891, "name": "Picoeukaryotes"},
        {"id": 892, "name": "Picoplankton"},
        {"id": 893, "name": "Pictures"},
        {"id": 894, "name": "Pigments"},
        {"id": 895, "name": "Pipeline"},
        {"id": 896, "name": "Plant biomass"},
        {"id": 897, "name": "Plant colonization"},
        {"id": 898, "name": "Plant succession"},
        {"id": 899, "name": "Plants"},
        {"id": 900, "name": "Plastics"},
        {"id": 901, "name": "Plovers"},
        {"id": 902, "name": "Polar bear"},
        {"id": 903, "name": "Polar desert"},
        {"id": 904, "name": "Polarization"},
        {"id": 905, "name": "Polarized light"},
        {"id": 906, "name": "Pollen"},
        {"id": 907, "name": "Polygonal terrain"},
        {"id": 908, "name": "Polymers"},
        {"id": 909, "name": "Polynya"},
        {"id": 910, "name": "Ponds"},
        {"id": 911, "name": "Population dynamics"},
        {"id": 912, "name": "Populations"},
        {"id": 913, "name": "Porcupine caribou herd"},
        {"id": 914, "name": "Post-glacial uplift"},
        {"id": 915, "name": "Precipitation"},
        {"id": 916, "name": "Predation"},
        {"id": 917, "name": "Predation impacts"},
        {"id": 918, "name": "Predator-prey interactions"},
        {"id": 919, "name": "Pressure"},
        {"id": 920, "name": "Primary production"},
        {"id": 921, "name": "Priming effect"},
        {"id": 922, "name": "Profiler"},
        {"id": 923, "name": "Protists"},
        {"id": 924, "name": "Protostrongylidae"},
        {"id": 925, "name": "Qamanirjuaq caribou herd"},
        {"id": 926, "name": "Quaternary"},
        {"id": 927, "name": "Radar"},
        {"id": 928, "name": "RADARSAT"},
        {"id": 929, "name": "Radial growth"},
        {"id": 930, "name": "Radiation"},
        {"id": 931, "name": "Radio scattering"},
        {"id": 932, "name": "Radio telemetry"},
        {"id": 933, "name": "Radiochronology"},
        {"id": 934, "name": "Radiometer"},
        {"id": 935, "name": "Radiometric dating"},
        {"id": 936, "name": "Raptors"},
        {"id": 937, "name": "Rare Earth Elements"},
        {"id": 938, "name": "Red fox"},
        {"id": 939, "name": "Regional variations"},
        {"id": 940, "name": "Reindeer"},
        {"id": 941, "name": "Relative humidity"},
        {"id": 942, "name": "Remote sensing data"},
        {"id": 943, "name": "Renewable"},
        {"id": 944, "name": "Reproductive ecology"},
        {"id": 945, "name": "Reproductive phenology"},
        {"id": 946, "name": "Reproductive success"},
        {"id": 947, "name": "Reptiles"},
        {"id": 948, "name": "Resistivity"},
        {"id": 949, "name": "Resolution"},
        {"id": 950, "name": "Resources"},
        {"id": 951, "name": "Respiration"},
        {"id": 952, "name": "Retrogressive thaw slump"},
        {"id": 953, "name": "Ridges"},
        {"id": 954, "name": "Ringed seal"},
        {"id": 955, "name": "River"},
        {"id": 956, "name": "River ice"},
        {"id": 957, "name": "River water turbidity"},
        {"id": 958, "name": "Rivers"},
        {"id": 959, "name": "RNA"},
        {"id": 960, "name": "Rock Eval pyrolysis"},
        {"id": 961, "name": "Rodents"},
        {"id": 962, "name": "Rough-legged hawk"},
        {"id": 963, "name": "Roughness"},
        {"id": 964, "name": "RSF function"},
        {"id": 965, "name": "Réservoirs hydro-électriques"},
        {"id": 966, "name": "Salinity"},
        {"id": 967, "name": "Salmons"},
        {"id": 968, "name": "Salt rejection"},
        {"id": 969, "name": "Sandpipers"},
        {"id": 970, "name": "SAR"},
        {"id": 971, "name": "Satellite imagery"},
        {"id": 972, "name": "Satellite validation"},
        {"id": 973, "name": "Scanning electron microscope (SEM)"},
        {"id": 974, "name": "Scatterometer"},
        {"id": 975, "name": "Scenarios"},
        {"id": 976, "name": "Sculpins"},
        {"id": 977, "name": "Sea birds"},
        {"id": 978, "name": "Sea ice"},
        {"id": 979, "name": "Sea level"},
        {"id": 980, "name": "Seabed"},
        {"id": 981, "name": "Seals"},
        {"id": 982, "name": "Seawater"},
        {"id": 983, "name": "Secondary production"},
        {"id": 984, "name": "Sedge meadow"},
        {"id": 985, "name": "Sediment accumulation rate"},
        {"id": 986, "name": "Sediment cores"},
        {"id": 987, "name": "Sediment fluxes"},
        {"id": 988, "name": "Sedimentation rates"},
        {"id": 989, "name": "Sediments"},
        {"id": 990, "name": "Seeds"},
        {"id": 991, "name": "Sheep"},
        {"id": 992, "name": "Shorebirds"},
        {"id": 993, "name": "Shoreline"},
        {"id": 994, "name": "Short-eared owl"},
        {"id": 995, "name": "Shrimps"},
        {"id": 996, "name": "Shrub competition"},
        {"id": 997, "name": "Shrub growth"},
        {"id": 998, "name": "Shrubification"},
        {"id": 999, "name": "Shrubs"},
        {"id": 1000, "name": "Significant wave height"},
        {"id": 1001, "name": "Silica"},
        {"id": 1002, "name": "Slope"},
        {"id": 1003, "name": "Small mammals"},
        {"id": 1004, "name": "Snow"},
        {"id": 1005, "name": "Snow accumulation rates"},
        {"id": 1006, "name": "Snow cover"},
        {"id": 1007, "name": "Snow density"},
        {"id": 1008, "name": "Snow depth"},
        {"id": 1009, "name": "Snow fence"},
        {"id": 1010, "name": "Snow geese"},
        {"id": 1011, "name": "Snow manipulation"},
        {"id": 1012, "name": "Snow melt"},
        {"id": 1013, "name": "Snow Pit"},
        {"id": 1014, "name": "Snow profile"},
        {"id": 1015, "name": "Snow temperature"},
        {"id": 1016, "name": "Snow water equivalent (SWE)"},
        {"id": 1017, "name": "Snowy owl"},
        {"id": 1018, "name": "Social-ecological systems"},
        {"id": 1019, "name": "Soil chemistry"},
        {"id": 1020, "name": "Soil microbial biomass"},
        {"id": 1021, "name": "Soil microbiology"},
        {"id": 1022, "name": "Soil moisture"},
        {"id": 1023, "name": "Soil pH"},
        {"id": 1024, "name": "Soil temperature"},
        {"id": 1025, "name": "Soils"},
        {"id": 1026, "name": "Solar radiation"},
        {"id": 1027, "name": "Solute"},
        {"id": 1028, "name": "Southampton caribou herd"},
        {"id": 1029, "name": "Southern Oscillation"},
        {"id": 1030, "name": "Spatial data"},
        {"id": 1031, "name": "Spatial Distribution"},
        {"id": 1032, "name": "Species composition"},
        {"id": 1033, "name": "Spiders"},
        {"id": 1034, "name": "Sponges"},
        {"id": 1035, "name": "Spores"},
        {"id": 1036, "name": "Stable isotope analyses"},
        {"id": 1037, "name": "Stable isotope tracers"},
        {"id": 1038, "name": "Stamukhi"},
        {"id": 1039, "name": "Statistics"},
        {"id": 1040, "name": "Stomach contents"},
        {"id": 1041, "name": "Storm surge"},
        {"id": 1042, "name": "Storms"},
        {"id": 1043, "name": "Stratification"},
        {"id": 1044, "name": "Stratigraphy"},
        {"id": 1045, "name": "Stream"},
        {"id": 1046, "name": "Stream enhancement"},
        {"id": 1047, "name": "Stream flow"},
        {"id": 1048, "name": "Sub-bottom profiler"},
        {"id": 1049, "name": "Sulphate reduction"},
        {"id": 1050, "name": "Sulphur"},
        {"id": 1051, "name": "Summer melt"},
        {"id": 1052, "name": "Surface"},
        {"id": 1053, "name": "Surface ozone depletion"},
        {"id": 1054, "name": "Surface sediments"},
        {"id": 1055, "name": "Surface water runoff"},
        {"id": 1056, "name": "Surficial deposit"},
        {"id": 1057, "name": "Suspended sediments"},
        {"id": 1058, "name": "Sustainability"},
        {"id": 1059, "name": "Svalbard caribou herd"},
        {"id": 1060, "name": "Swans"},
        {"id": 1061, "name": "Sympagic meiofauna"},
        {"id": 1062, "name": "Taimyr caribou herd"},
        {"id": 1063, "name": "Talus"},
        {"id": 1064, "name": "Target strength"},
        {"id": 1065, "name": "Taux de croissance"},
        {"id": 1066, "name": "Taxonomy"},
        {"id": 1067, "name": "Telemetry"},
        {"id": 1068, "name": "Temperature"},
        {"id": 1069, "name": "Température du sol"},
        {"id": 1070, "name": "Terrestrial ecosystem"},
        {"id": 1071, "name": "Territories"},
        {"id": 1072, "name": "Teshekpuk Lake caribou herd"},
        {"id": 1073, "name": "test"},
        {"id": 1074, "name": "Thaw lakes"},
        {"id": 1075, "name": "Thawing"},
        {"id": 1076, "name": "Thermo-erosion gullies"},
        {"id": 1077, "name": "Thermodynamics"},
        {"id": 1078, "name": "Thermokarst"},
        {"id": 1079, "name": "Thick-billed murre"},
        {"id": 1080, "name": "Thin section"},
        {"id": 1081, "name": "Threatened"},
        {"id": 1082, "name": "Threshold"},
        {"id": 1083, "name": "Tides"},
        {"id": 1084, "name": "Topogram"},
        {"id": 1085, "name": "Topographic map"},
        {"id": 1086, "name": "Topographical surveys"},
        {"id": 1087, "name": "Topography"},
        {"id": 1088, "name": "Transducer"},
        {"id": 1089, "name": "Transect"},
        {"id": 1090, "name": "Transmittance"},
        {"id": 1091, "name": "Transpolar drift"},
        {"id": 1092, "name": "Traps"},
        {"id": 1093, "name": "Treeline"},
        {"id": 1094, "name": "Trees"},
        {"id": 1095, "name": "Trophic dynamics"},
        {"id": 1096, "name": "Tropopause"},
        {"id": 1097, "name": "Tropospheric mercury"},
        {"id": 1098, "name": "Tundra"},
        {"id": 1099, "name": "Turbidity"},
        {"id": 1100, "name": "Turbulence"},
        {"id": 1101, "name": "Turbulent fluxes"},
        {"id": 1102, "name": "Ultraviolet radiation"},
        {"id": 1103, "name": "Underflow"},
        {"id": 1104, "name": "Ungulates"},
        {"id": 1105, "name": "Upwelling"},
        {"id": 1106, "name": "Vaccinium uliginosum"},
        {"id": 1107, "name": "Varve"},
        {"id": 1108, "name": "Vascular plants"},
        {"id": 1109, "name": "Vegetation"},
        {"id": 1110, "name": "Velocity"},
        {"id": 1111, "name": "Vertical distribution"},
        {"id": 1112, "name": "Viabilité des graines"},
        {"id": 1113, "name": "Virus"},
        {"id": 1114, "name": "Voles"},
        {"id": 1115, "name": "Végétation"},
        {"id": 1116, "name": "Walrus"},
        {"id": 1117, "name": "Water"},
        {"id": 1118, "name": "Water balance"},
        {"id": 1119, "name": "Water budget"},
        {"id": 1120, "name": "Water chemistry"},
        {"id": 1121, "name": "Water column"},
        {"id": 1122, "name": "Water density"},
        {"id": 1123, "name": "Water level"},
        {"id": 1124, "name": "Water supply"},
        {"id": 1125, "name": "Water temperature"},
        {"id": 1126, "name": "Water tracks"},
        {"id": 1127, "name": "Water vapour flux"},
        {"id": 1128, "name": "Water-air gas exchange"},
        {"id": 1129, "name": "Waterfowl"},
        {"id": 1130, "name": "Watershed"},
        {"id": 1131, "name": "Wave parameters"},
        {"id": 1132, "name": "Wave spectrum"},
        {"id": 1133, "name": "Waves"},
        {"id": 1134, "name": "Weasels"},
        {"id": 1135, "name": "Weather"},
        {"id": 1136, "name": "Webcam"},
        {"id": 1137, "name": "Western Arctic caribou herd"},
        {"id": 1138, "name": "Wetland"},
        {"id": 1139, "name": "Whales"},
        {"id": 1140, "name": "White spruce"},
        {"id": 1141, "name": "White-rumped sandpiper"},
        {"id": 1142, "name": "Wildlife"},
        {"id": 1143, "name": "Wildlife management"},
        {"id": 1144, "name": "Willow (Salix)"},
        {"id": 1145, "name": "Wind direction"},
        {"id": 1146, "name": "Wind speed"},
        {"id": 1147, "name": "Winds"},
        {"id": 1148, "name": "Wolverine"},
        {"id": 1149, "name": "Wolves"},
        {"id": 1150, "name": "X-radiography"},
        {"id": 1151, "name": "Yukon Dolly Varden charr"},
        {"id": 1152, "name": "Zoobenthos"},
        {"id": 1153, "name": "Zoology"},
        {"id": 1154, "name": "Zooplankton"},
        {"id": 1155, "name": "Écotone forêt-toundra"},
        {"id": 1156, "name": "Établissement de plantules"},
        {"id": 1157, "name": "Aklavik"},
        {"id": 1158, "name": "Akulivik"},
        {"id": 1159, "name": "Alert"},
        {"id": 1160, "name": "Arctic Bay"},
        {"id": 1161, "name": "Arviat"},
        {"id": 1162, "name": "Aupaluk"},
        {"id": 1163, "name": "Baker Lake"},
        {"id": 1164, "name": "Bathurst Inlet"},
        {"id": 1165, "name": "Bay Chimo"},
        {"id": 1166, "name": "Cambridge Bay"},
        {"id": 1167, "name": "Cape Dorset"},
        {"id": 1168, "name": "Chesterfield Inlet"},
        {"id": 1169, "name": "Churchill Falls"},
        {"id": 1170, "name": "Clyde River"},
        {"id": 1171, "name": "Colville Lake"},
        {"id": 1172, "name": "Coral Harbour"},
        {"id": 1173, "name": "Davis Inlet"},
        {"id": 1174, "name": "Deline"},
        {"id": 1175, "name": "Eureka"},
        {"id": 1176, "name": "Fort Good Hope"},
        {"id": 1177, "name": "Fort McPherson"},
        {"id": 1178, "name": "Gameti"},
        {"id": 1179, "name": "Gjoa Haven"},
        {"id": 1180, "name": "Grise Fiord"},
        {"id": 1181, "name": "Hall Beach"},
        {"id": 1182, "name": "Holman"},
        {"id": 1183, "name": "Hopedale"},
        {"id": 1184, "name": "Igloolik"},
        {"id": 1185, "name": "Inukjuak"},
        {"id": 1186, "name": "Inuvik"},
        {"id": 1187, "name": "Iqaluit"},
        {"id": 1188, "name": "Ivujivik"},
        {"id": 1189, "name": "Jean Marie River"},
        {"id": 1190, "name": "Kangiqsualujjuaq"},
        {"id": 1191, "name": "Kangiqsujuaq"},
        {"id": 1192, "name": "Kangirsuk"},
        {"id": 1193, "name": "Kawawachikamach"},
        {"id": 1194, "name": "Kimmirut"},
        {"id": 1195, "name": "Kugaaruk"},
        {"id": 1196, "name": "Kugluktuk"},
        {"id": 1197, "name": "Kuujjuaq"},
        {"id": 1198, "name": "Kuujjuaraapik"},
        {"id": 1199, "name": "Lutsel K'e"},
        {"id": 1200, "name": "Makkovik"},
        {"id": 1201, "name": "Mittimatalik"},
        {"id": 1202, "name": "Nain"},
        {"id": 1203, "name": "Nanisivik"},
        {"id": 1204, "name": "Norman Wells"},
        {"id": 1205, "name": "Old Crow"},
        {"id": 1206, "name": "Pangnirtung"},
        {"id": 1207, "name": "Paulatuk"},
        {"id": 1208, "name": "Paulatuuq"},
        {"id": 1209, "name": "Pelly Bay"},
        {"id": 1210, "name": "Pond Inlet"},
        {"id": 1211, "name": "Postville"},
        {"id": 1212, "name": "Puvirnituq"},
        {"id": 1213, "name": "Qausuittuq"},
        {"id": 1214, "name": "Qikiqtarjuaq"},
        {"id": 1215, "name": "Qiqiktarjuaq"},
        {"id": 1216, "name": "Quaqtaq"},
        {"id": 1217, "name": "Radisson"},
        {"id": 1218, "name": "Rankin Inlet"},
        {"id": 1219, "name": "Repulse Bay"},
        {"id": 1220, "name": "Resolute"},
        {"id": 1221, "name": "Rigolet"},
        {"id": 1222, "name": "Sachs Harbour"},
        {"id": 1223, "name": "Salluit"},
        {"id": 1224, "name": "Sanikiluaq"},
        {"id": 1225, "name": "Southern Tutchone"},
        {"id": 1226, "name": "Taloyoak"},
        {"id": 1227, "name": "Tasiujaq"},
        {"id": 1228, "name": "Tlingit"},
        {"id": 1229, "name": "Tsiigehtchic"},
        {"id": 1230, "name": "Tuktoyaktuk"},
        {"id": 1231, "name": "Tulita"},
        {"id": 1232, "name": "Ulukhaktok"},
        {"id": 1233, "name": "Umiujaq"},
        {"id": 1234, "name": "Whale Cove"},
        {"id": 1235, "name": "Aboriginal land claim"},
        {"id": 1236, "name": "Aboriginal organizations"},
        {"id": 1237, "name": "Adaptation"},
        {"id": 1238, "name": "Airports"},
        {"id": 1239, "name": "Archaeology"},
        {"id": 1240, "name": "Artifacts"},
        {"id": 1241, "name": "Berry picking"},
        {"id": 1242, "name": "Capacity building"},
        {"id": 1243, "name": "Clam gathering"},
        {"id": 1244, "name": "Communication"},
        {"id": 1245, "name": "Community freezer"},
        {"id": 1246, "name": "Community infrastructure"},
        {"id": 1247, "name": "Community mobilization"},
        {"id": 1248, "name": "Community vulnerability"},
        {"id": 1249, "name": "Conservation"},
        {"id": 1250, "name": "Cooperation"},
        {"id": 1251, "name": "Cultural development"},
        {"id": 1252, "name": "Cultural landscape"},
        {"id": 1253, "name": "Cultural preservation"},
        {"id": 1254, "name": "Cultural values"},
        {"id": 1255, "name": "Database (socioeconomic)"},
        {"id": 1256, "name": "Decision makers"},
        {"id": 1257, "name": "Demography"},
        {"id": 1258, "name": "Denesuline"},
        {"id": 1259, "name": "Diabetes"},
        {"id": 1260, "name": "Diplomacy"},
        {"id": 1261, "name": "Doctrines"},
        {"id": 1262, "name": "Economic value"},
        {"id": 1263, "name": "Economics"},
        {"id": 1264, "name": "Education"},
        {"id": 1265, "name": "Elders"},
        {"id": 1266, "name": "Entrepreneurship"},
        {"id": 1267, "name": "Environment surveillance"},
        {"id": 1268, "name": "Environmental health"},
        {"id": 1269, "name": "Ethic"},
        {"id": 1270, "name": "Ethnography"},
        {"id": 1271, "name": "Exposure"},
        {"id": 1272, "name": "Financial resources"},
        {"id": 1273, "name": "Fishing"},
        {"id": 1274, "name": "Food security"},
        {"id": 1275, "name": "Foreign policy"},
        {"id": 1276, "name": "Funding"},
        {"id": 1277, "name": "Future exposure"},
        {"id": 1278, "name": "Gender"},
        {"id": 1279, "name": "Globalization"},
        {"id": 1280, "name": "Government"},
        {"id": 1281, "name": "Governmental policies"},
        {"id": 1282, "name": "Habitat vulnerability"},
        {"id": 1283, "name": "Harvesting site"},
        {"id": 1284, "name": "Healing"},
        {"id": 1285, "name": "Health promotion"},
        {"id": 1286, "name": "Homelessness"},
        {"id": 1287, "name": "Housing"},
        {"id": 1288, "name": "Human adaptation"},
        {"id": 1289, "name": "Human health"},
        {"id": 1290, "name": "Human occupation"},
        {"id": 1291, "name": "Human perception"},
        {"id": 1292, "name": "Human remains"},
        {"id": 1293, "name": "Human resources"},
        {"id": 1294, "name": "Human rights"},
        {"id": 1295, "name": "Human-made hazards"},
        {"id": 1296, "name": "Human-wildlife relationships"},
        {"id": 1297, "name": "Hunting"},
        {"id": 1298, "name": "Hunting location"},
        {"id": 1299, "name": "Impact assessments"},
        {"id": 1300, "name": "Indigenous peoples"},
        {"id": 1301, "name": "Industries"},
        {"id": 1302, "name": "Information sharing"},
        {"id": 1303, "name": "International law"},
        {"id": 1304, "name": "International relations"},
        {"id": 1305, "name": "Interview"},
        {"id": 1306, "name": "Inuit entrepreneurship"},
        {"id": 1307, "name": "Inuit Knowledge"},
        {"id": 1308, "name": "Inuit population"},
        {"id": 1309, "name": "Inuit Tapiriit Kanatami (ITK)"},
        {"id": 1310, "name": "Inuit Tuttarvingat (of NAHO)"},
        {"id": 1311, "name": "James Bay and Northern Québec Agreement"},
        {"id": 1312, "name": "Knowledge transfer"},
        {"id": 1313, "name": "Kwädāy Dän Ts¿ínchį"},
        {"id": 1314, "name": "Kyoto Protocol"},
        {"id": 1315, "name": "Land claims"},
        {"id": 1316, "name": "Landuse"},
        {"id": 1317, "name": "Law"},
        {"id": 1318, "name": "Law of the Sea Convention"},
        {"id": 1319, "name": "Legacy"},
        {"id": 1320, "name": "Legal research"},
        {"id": 1321, "name": "Legal strategies"},
        {"id": 1322, "name": "Livelihood"},
        {"id": 1323, "name": "Makivik Corporation"},
        {"id": 1324, "name": "Management"},
        {"id": 1325, "name": "Marine navigation"},
        {"id": 1326, "name": "Marine transport"},
        {"id": 1327, "name": "Meteorological hazards"},
        {"id": 1328, "name": "Model"},
        {"id": 1329, "name": "Modernization"},
        {"id": 1330, "name": "Municipal authorities"},
        {"id": 1331, "name": "National defence"},
        {"id": 1332, "name": "Northerners"},
        {"id": 1333, "name": "Nunatsiavut Government"},
        {"id": 1334, "name": "Nunavut Government"},
        {"id": 1335, "name": "Open-dialogue"},
        {"id": 1336, "name": "Organizations"},
        {"id": 1337, "name": "Parks"},
        {"id": 1338, "name": "Partnerships"},
        {"id": 1339, "name": "Pilot projects"},
        {"id": 1340, "name": "Policy"},
        {"id": 1341, "name": "Politics"},
        {"id": 1342, "name": "Portage"},
        {"id": 1343, "name": "Poverty"},
        {"id": 1344, "name": "Practical legislations"},
        {"id": 1345, "name": "Raglan Agreement"},
        {"id": 1346, "name": "Rail"},
        {"id": 1347, "name": "Recreational hunting"},
        {"id": 1348, "name": "Regional development"},
        {"id": 1349, "name": "Regional scale modeling"},
        {"id": 1350, "name": "Regulation"},
        {"id": 1351, "name": "Resilience"},
        {"id": 1352, "name": "Resource development"},
        {"id": 1353, "name": "Resource management strategies"},
        {"id": 1354, "name": "Roads"},
        {"id": 1355, "name": "Sanarrutik Agreement"},
        {"id": 1356, "name": "Scenario"},
        {"id": 1357, "name": "Schools"},
        {"id": 1358, "name": "Self-determination"},
        {"id": 1359, "name": "Shipping"},
        {"id": 1360, "name": "Social benefits"},
        {"id": 1361, "name": "Social change"},
        {"id": 1362, "name": "Social cost"},
        {"id": 1363, "name": "Social impacts"},
        {"id": 1364, "name": "Social integration"},
        {"id": 1365, "name": "Social sciences"},
        {"id": 1366, "name": "Socio-economic impacts"},
        {"id": 1367, "name": "Sovereignty"},
        {"id": 1368, "name": "Spirituality"},
        {"id": 1369, "name": "Sport hunting"},
        {"id": 1370, "name": "Stakeholders"},
        {"id": 1371, "name": "Strategies"},
        {"id": 1372, "name": "Suicide"},
        {"id": 1373, "name": "Technological resources"},
        {"id": 1374, "name": "Thule"},
        {"id": 1375, "name": "Tourism"},
        {"id": 1376, "name": "Traditional Ecological Knowledge (TEK)"},
        {"id": 1377, "name": "Traditional economy"},
        {"id": 1378, "name": "Traditional Knowledge"},
        {"id": 1379, "name": "Traditional language"},
        {"id": 1380, "name": "Training"},
        {"id": 1381, "name": "Transportation"},
        {"id": 1382, "name": "Trappers"},
        {"id": 1383, "name": "Villages"},
        {"id": 1384, "name": "Vocational education"},
        {"id": 1385, "name": "Vulnerability"},
        {"id": 1386, "name": "Wage economy"},
        {"id": 1387, "name": "Wellness"},
        {"id": 1388, "name": "Whaling"},
        {"id": 1389, "name": "Wooden artifacts"},
        {"id": 1390, "name": "Youth education"},
        {"id": 1391, "name": "Youth perspectives"},
        {"id": 1392, "name": "Archive"},
        {"id": 1393, "name": "Bibliography"},
        {"id": 1394, "name": "Book"},
        {"id": 1395, "name": "Citizen science"},
        {"id": 1396, "name": "Construction"},
        {"id": 1397, "name": "CRYSYS"},
        {"id": 1398, "name": "Data centre"},
        {"id": 1399, "name": "Data portal"},
        {"id": 1400, "name": "Database (transdisciplinary)"},
        {"id": 1401, "name": "Dredging"},
        {"id": 1402, "name": "guardians"},
        {"id": 1403, "name": "Harvest"},
        {"id": 1404, "name": "Library"},
        {"id": 1405, "name": "Mining"},
        {"id": 1406, "name": "Multidisciplinary"},
        {"id": 1407, "name": "Network"},
        {"id": 1408, "name": "Petroleum industry"},
        {"id": 1409, "name": "Publication"},
        {"id": 1410, "name": "Report"},
        {"id": 1411, "name": "Statistics (transdisciplinary)"},
        {"id": 1412, "name": "Study"},
        {"id": 1413, "name": "Travelling"},
        {"id": 1414, "name": "Unmanned Aerial Vehicle (UAV)"},
];

export const keyOptions = [
    {"value": "Akimiski Island", "label": "Akimiski Island"},
    {"value": "Alaska", "label": "Alaska"},
    {"value": "Alexandra Fiord", "label": "Alexandra Fiord"},
    {"value": "Amundsen Gulf", "label": "Amundsen Gulf"},
    {"value": "Anaktalak Bay", "label": "Anaktalak Bay"},
    {"value": "Antarctic", "label": "Antarctic"},
    {"value": "Apex River", "label": "Apex River"},
    {"value": "Arctic", "label": "Arctic"},
    {"value": "Arctic Ocean", "label": "Arctic Ocean"},
    {"value": "Asia", "label": "Asia"},
    {"value": "Aulavik", "label": "Aulavik"},
    {"value": "Auyuittuq", "label": "Auyuittuq"},
    {"value": "Axel Heiberg Island", "label": "Axel Heiberg Island"},
    {"value": "Ayles Fiord", "label": "Ayles Fiord"},
    {"value": "Ayles Ice Shelf", "label": "Ayles Ice Shelf"},
    {"value": "Aylmer Lake", "label": "Aylmer Lake"},
    {"value": "Back River", "label": "Back River"},
    {"value": "Baffin Bay", "label": "Baffin Bay"},
    {"value": "Baffin Island", "label": "Baffin Island"},
    {"value": "Banks Island", "label": "Banks Island"},
    {"value": "Barents Sea", "label": "Barents Sea"},
    {"value": "Barrow Strait", "label": "Barrow Strait"},
    {"value": "Bathurst Island", "label": "Bathurst Island"},
    {"value": "Beaufort Sea", "label": "Beaufort Sea"},
    {"value": "Boreal", "label": "Boreal"},
    {"value": "Bylot Island", "label": "Bylot Island"},
    {"value": "Canada", "label": "Canada"},
    {"value": "Canadian Arctic Archipelago", "label": "Canadian Arctic Archipelago"},
    {"value": "Canadian High Arctic", "label": "Canadian High Arctic"},
    {"value": "Cape Bounty", "label": "Cape Bounty"},
    {"value": "Cape Churchill", "label": "Cape Churchill"},
    {"value": "Char Lake", "label": "Char Lake"},
    {"value": "Chukchi Sea", "label": "Chukchi Sea"},
    {"value": "Churchill River", "label": "Churchill River"},
    {"value": "Circumpolar region", "label": "Circumpolar region"},
    {"value": "Cornwallis Island", "label": "Cornwallis Island"},
    {"value": "Creswell Bay", "label": "Creswell Bay"},
    {"value": "Cumberland Sound", "label": "Cumberland Sound"},
    {"value": "Daneborg", "label": "Daneborg"},
    {"value": "Daring Lake", "label": "Daring Lake"},
    {"value": "Davis Strait", "label": "Davis Strait"},
    {"value": "Devon Island", "label": "Devon Island"},
    {"value": "Disraeli Fiord", "label": "Disraeli Fiord"},
    {"value": "Drayton Island", "label": "Drayton Island"},
    {"value": "East Bay", "label": "East Bay"},
    {"value": "Eastwind Lake", "label": "Eastwind Lake"},
    {"value": "Eclipse Sound", "label": "Eclipse Sound"},
    {"value": "Ellef Ringnes Island", "label": "Ellef Ringnes Island"},
    {"value": "Ellesmere Island", "label": "Ellesmere Island"},
    {"value": "Eureka Sound", "label": "Eureka Sound"},
    {"value": "Europe", "label": "Europe"},
    {"value": "Finland", "label": "Finland"},
    {"value": "Fosheim Peninsula", "label": "Fosheim Peninsula"},
    {"value": "Foxe Basin", "label": "Foxe Basin"},
    {"value": "Franklin Bay", "label": "Franklin Bay"},
    {"value": "Frobisher Bay", "label": "Frobisher Bay"},
    {"value": "Fungal endophytes", "label": "Fungal endophytes"},
    {"value": "Funk Island", "label": "Funk Island"},
    {"value": "Gladstone Lakes", "label": "Gladstone Lakes"},
    {"value": "Global", "label": "Global"},
    {"value": "Goose Bay", "label": "Goose Bay"},
    {"value": "Goose River", "label": "Goose River"},
    {"value": "Grand Banks", "label": "Grand Banks"},
    {"value": "Grand Lake", "label": "Grand Lake"},
    {"value": "Great Lakes", "label": "Great Lakes"},
    {"value": "Greenland", "label": "Greenland"},
    {"value": "Greiner Lake", "label": "Greiner Lake"},
    {"value": "Griffith Island", "label": "Griffith Island"},
    {"value": "Gulf of St. Lawrence", "label": "Gulf of St. Lawrence"},
    {"value": "Herschel Island", "label": "Herschel Island"},
    {"value": "Himalaya", "label": "Himalaya"},
    {"value": "Horanaday River", "label": "Horanaday River"},
    {"value": "Hudson Bay", "label": "Hudson Bay"},
    {"value": "Hudson Strait", "label": "Hudson Strait"},
    {"value": "Iceland", "label": "Iceland"},
    {"value": "Inuit Nunangat", "label": "Inuit Nunangat"},
    {"value": "Inuvialuit", "label": "Inuvialuit"},
    {"value": "Ivvavik", "label": "Ivvavik"},
    {"value": "James Bay", "label": "James Bay"},
    {"value": "Jones Sound", "label": "Jones Sound"},
    {"value": "Kangirsualujjuaq", "label": "Kangirsualujjuaq"},
    {"value": "Kangirsujuaq", "label": "Kangirsujuaq"},
    {"value": "Kara Sea", "label": "Kara Sea"},
    {"value": "Kazan River", "label": "Kazan River"},
    {"value": "Kent Peninsula", "label": "Kent Peninsula"},
    {"value": "Kivalliq", "label": "Kivalliq"},
    {"value": "Kluane", "label": "Kluane"},
    {"value": "Kluane national park", "label": "Kluane national park"},
    {"value": "Komakuk Beach", "label": "Komakuk Beach"},
    {"value": "Kosoak", "label": "Kosoak"},
    {"value": "La Grande Basin", "label": "La Grande Basin"},
    {"value": "La Perouse Bay", "label": "La Perouse Bay"},
    {"value": "Labrador", "label": "Labrador"},
    {"value": "Labrador Sea", "label": "Labrador Sea"},
    {"value": "Lac à l'Eau Claire", "label": "Lac à l'Eau Claire"},
    {"value": "Lake A", "label": "Lake A"},
    {"value": "Lake Amituk", "label": "Lake Amituk"},
    {"value": "Lake Erie", "label": "Lake Erie"},
    {"value": "Lake Hazen", "label": "Lake Hazen"},
    {"value": "Lake Huron", "label": "Lake Huron"},
    {"value": "Lake Melville", "label": "Lake Melville"},
    {"value": "Lake Ontario", "label": "Lake Ontario"},
    {"value": "Lake Resolute", "label": "Lake Resolute"},
    {"value": "Lake Superior", "label": "Lake Superior"},
    {"value": "Lancaster Sound", "label": "Lancaster Sound"},
    {"value": "Lapland", "label": "Lapland"},
    {"value": "Laptev Sea", "label": "Laptev Sea"},
    {"value": "Lena River", "label": "Lena River"},
    {"value": "Lowther Island", "label": "Lowther Island"},
    {"value": "Mackenzie Mountains", "label": "Mackenzie Mountains"},
    {"value": "Mackenzie River", "label": "Mackenzie River"},
    {"value": "Mackenzie Shelf", "label": "Mackenzie Shelf"},
    {"value": "Makkovik Bay", "label": "Makkovik Bay"},
    {"value": "Manitoba", "label": "Manitoba"},
    {"value": "Markham Fiord", "label": "Markham Fiord"},
    {"value": "Markham Ice Shelf", "label": "Markham Ice Shelf"},
    {"value": "Meadowbank River", "label": "Meadowbank River"},
    {"value": "Meliadine River", "label": "Meliadine River"},
    {"value": "Melville Island", "label": "Melville Island"},
    {"value": "Melville Peninsula", "label": "Melville Peninsula"},
    {"value": "Milne Ice Shelf", "label": "Milne Ice Shelf"},
    {"value": "Nachvak Fiord", "label": "Nachvak Fiord"},
    {"value": "Nahanni", "label": "Nahanni"},
    {"value": "Nares Strait", "label": "Nares Strait"},
    {"value": "Nepihjee River", "label": "Nepihjee River"},
    {"value": "Newfoundland", "label": "Newfoundland"},
    {"value": "Newfoundland Shelf", "label": "Newfoundland Shelf"},
    {"value": "Niaqunguk River", "label": "Niaqunguk River"},
    {"value": "North America", "label": "North America"},
    {"value": "North Pole", "label": "North Pole"},
    {"value": "North Water Polynya", "label": "North Water Polynya"},
    {"value": "Northern Canada", "label": "Northern Canada"},
    {"value": "Northern Hemisphere", "label": "Northern Hemisphere"},
    {"value": "Northwest Atlantic Ocean", "label": "Northwest Atlantic Ocean"},
    {"value": "Northwest Passage", "label": "Northwest Passage"},
    {"value": "Northwest Territories", "label": "Northwest Territories"},
    {"value": "Norway", "label": "Norway"},
    {"value": "Nunatsiavut", "label": "Nunatsiavut"},
    {"value": "Nunavik", "label": "Nunavik"},
    {"value": "Nunavut", "label": "Nunavut"},
    {"value": "Nuuk", "label": "Nuuk"},
    {"value": "Okak Bay", "label": "Okak Bay"},
    {"value": "Old Factory River", "label": "Old Factory River"},
    {"value": "Oliver Sound", "label": "Oliver Sound"},
    {"value": "Ontario", "label": "Ontario"},
    {"value": "Pechora River", "label": "Pechora River"},
    {"value": "Pechora Sea", "label": "Pechora Sea"},
    {"value": "Petermann Glacier", "label": "Petermann Glacier"},
    {"value": "Pingualuit", "label": "Pingualuit"},
    {"value": "Polaris Mine", "label": "Polaris Mine"},
    {"value": "Postglacial Tyrrell Sea", "label": "Postglacial Tyrrell Sea"},
    {"value": "Prince of Wales Icefield", "label": "Prince of Wales Icefield"},
    {"value": "Queen Elizabeth Islands", "label": "Queen Elizabeth Islands"},
    {"value": "Quttinirpaaq", "label": "Quttinirpaaq"},
    {"value": "Quttinirpaaq national park", "label": "Quttinirpaaq national park"},
    {"value": "Québec", "label": "Québec"},
    {"value": "Rambow Bay", "label": "Rambow Bay"},
    {"value": "Resolute Bay", "label": "Resolute Bay"},
    {"value": "Russia", "label": "Russia"},
    {"value": "Russian Federation", "label": "Russian Federation"},
    {"value": "Saglek Bay", "label": "Saglek Bay"},
    {"value": "Saskatchewan", "label": "Saskatchewan"},
    {"value": "Sewage treatment", "label": "Sewage treatment"},
    {"value": "Siberian Arctic", "label": "Siberian Arctic"},
    {"value": "Sirmilik", "label": "Sirmilik"},
    {"value": "Southampton Island", "label": "Southampton Island"},
    {"value": "St. Helena Island", "label": "St. Helena Island"},
    {"value": "Subantarctic", "label": "Subantarctic"},
    {"value": "Subarctic", "label": "Subarctic"},
    {"value": "Subarctique", "label": "Subarctique"},
    {"value": "Svalbard", "label": "Svalbard"},
    {"value": "Sverdrup Pass", "label": "Sverdrup Pass"},
    {"value": "Sweden", "label": "Sweden"},
    {"value": "Taimyr Peninsula", "label": "Taimyr Peninsula"},
    {"value": "Tanquary Fiord", "label": "Tanquary Fiord"},
    {"value": "Tatshenshini-Alsek Park", "label": "Tatshenshini-Alsek Park"},
    {"value": "Tehek Lake", "label": "Tehek Lake"},
    {"value": "Thelon River", "label": "Thelon River"},
    {"value": "Torngat Mountains", "label": "Torngat Mountains"},
    {"value": "Tuktoyaktuk Peninsula", "label": "Tuktoyaktuk Peninsula"},
    {"value": "Tuktut Nogait", "label": "Tuktut Nogait"},
    {"value": "Ukkusuksalik", "label": "Ukkusuksalik"},
    {"value": "Ungava Bay", "label": "Ungava Bay"},
    {"value": "Ungava Peninsula", "label": "Ungava Peninsula"},
    {"value": "Victoria Island", "label": "Victoria Island"},
    {"value": "Viscount Melville Sound", "label": "Viscount Melville Sound"},
    {"value": "Voisey's Bay", "label": "Voisey's Bay"},
    {"value": "Vuntut", "label": "Vuntut"},
    {"value": "Wadham Islands", "label": "Wadham Islands"},
    {"value": "Walker Bay", "label": "Walker Bay"},
    {"value": "Wapusk", "label": "Wapusk"},
    {"value": "Ward Hunt Ice Shelf", "label": "Ward Hunt Ice Shelf"},
    {"value": "Ward Hunt Island", "label": "Ward Hunt Island"},
    {"value": "Ward Hunt Lake", "label": "Ward Hunt Lake"},
    {"value": "White Sea", "label": "White Sea"},
    {"value": "Yukon", "label": "Yukon"},
    {"value": "Altitude", "label": "Altitude"},
    {"value": "Anions", "label": "Anions"},
    {"value": "Anisakidae", "label": "Anisakidae"},
    {"value": "Antibodies", "label": "Antibodies"},
    {"value": "Atherosclerosis", "label": "Atherosclerosis"},
    {"value": "Atmospheric elemental mercury", "label": "Atmospheric elemental mercury"},
    {"value": "Bioaccumulation", "label": "Bioaccumulation"},
    {"value": "Blizzards", "label": "Blizzards"},
    {"value": "Blood lipids", "label": "Blood lipids"},
    {"value": "Blood pressure", "label": "Blood pressure"},
    {"value": "Blood samples", "label": "Blood samples"},
    {"value": "Blowing snow", "label": "Blowing snow"},
    {"value": "Brominated diphenyl ethers", "label": "Brominated diphenyl ethers"},
    {"value": "Brucella", "label": "Brucella"},
    {"value": "Brucellosis", "label": "Brucellosis"},
    {"value": "Cadmium", "label": "Cadmium"},
    {"value": "Campylobacter", "label": "Campylobacter"},
    {"value": "Cancer", "label": "Cancer"},
    {"value": "Cardiovascular risk factors", "label": "Cardiovascular risk factors"},
    {"value": "Cerebellum", "label": "Cerebellum"},
    {"value": "Children", "label": "Children"},
    {"value": "Chronology", "label": "Chronology"},
    {"value": "Clostridium", "label": "Clostridium"},
    {"value": "Community health", "label": "Community health"},
    {"value": "Coxiella", "label": "Coxiella"},
    {"value": "Cryptosporidium", "label": "Cryptosporidium"},
    {"value": "Cumulative effects", "label": "Cumulative effects"},
    {"value": "Current use pesticide", "label": "Current use pesticide"},
    {"value": "Cushion plants", "label": "Cushion plants"},
    {"value": "Database (contaminants)", "label": "Database (contaminants)"},
    {"value": "Database (health)", "label": "Database (health)"},
    {"value": "DDT", "label": "DDT"},
    {"value": "Desulfovibrio", "label": "Desulfovibrio"},
    {"value": "Development", "label": "Development"},
    {"value": "Diagenesis", "label": "Diagenesis"},
    {"value": "Diagnostic methods", "label": "Diagnostic methods"},
    {"value": "Diet", "label": "Diet"},
    {"value": "Digestion assay", "label": "Digestion assay"},
    {"value": "Dimethylmercury", "label": "Dimethylmercury"},
    {"value": "Disease", "label": "Disease"},
    {"value": "Dissolved gaseous mercury", "label": "Dissolved gaseous mercury"},
    {"value": "Distribution (Contaminants)", "label": "Distribution (Contaminants)"},
    {"value": "E. coli", "label": "E. coli"},
    {"value": "Echinicoccus", "label": "Echinicoccus"},
    {"value": "Echinococcosis", "label": "Echinococcosis"},
    {"value": "Ecophysiology", "label": "Ecophysiology"},
    {"value": "Ecotoxicology", "label": "Ecotoxicology"},
    {"value": "Enterococcus", "label": "Enterococcus"},
    {"value": "Enzyme", "label": "Enzyme"},
    {"value": "F-specific coliphages", "label": "F-specific coliphages"},
    {"value": "Food consumption", "label": "Food consumption"},
    {"value": "Francisella", "label": "Francisella"},
    {"value": "Freshwater availability", "label": "Freshwater availability"},
    {"value": "Freshwater quality", "label": "Freshwater quality"},
    {"value": "Gastroenteritis", "label": "Gastroenteritis"},
    {"value": "Giardia", "label": "Giardia"},
    {"value": "Greenhouse gases", "label": "Greenhouse gases"},
    {"value": "Halogenated phenolics", "label": "Halogenated phenolics"},
    {"value": "Health", "label": "Health"},
    {"value": "Health communication", "label": "Health communication"},
    {"value": "Health risk", "label": "Health risk"},
    {"value": "Health status", "label": "Health status"},
    {"value": "Health survey", "label": "Health survey"},
    {"value": "Hearing disorders", "label": "Hearing disorders"},
    {"value": "Heart disease", "label": "Heart disease"},
    {"value": "Heavy metal", "label": "Heavy metal"},
    {"value": "Hepatitis B", "label": "Hepatitis B"},
    {"value": "Herbicides", "label": "Herbicides"},
    {"value": "Hospital archives", "label": "Hospital archives"},
    {"value": "HPCs", "label": "HPCs"},
    {"value": "Human Papillomavirus", "label": "Human Papillomavirus"},
    {"value": "Hydatid disease", "label": "Hydatid disease"},
    {"value": "Hydrocarbon", "label": "Hydrocarbon"},
    {"value": "Hydroxylated metabolites", "label": "Hydroxylated metabolites"},
    {"value": "Hypothermia", "label": "Hypothermia"},
    {"value": "Inuit Health Survey", "label": "Inuit Health Survey"},
    {"value": "Inuit lifestyles", "label": "Inuit lifestyles"},
    {"value": "Junk food", "label": "Junk food"},
    {"value": "Lake varve", "label": "Lake varve"},
    {"value": "Legacy pesticide", "label": "Legacy pesticide"},
    {"value": "Leptospira", "label": "Leptospira"},
    {"value": "Leptospirosis", "label": "Leptospirosis"},
    {"value": "Lifestyle", "label": "Lifestyle"},
    {"value": "Light", "label": "Light"},
    {"value": "Lipid", "label": "Lipid"},
    {"value": "Liver cirrhosis", "label": "Liver cirrhosis"},
    {"value": "Maternity care", "label": "Maternity care"},
    {"value": "MDE", "label": "MDE"},
    {"value": "Medical authorities", "label": "Medical authorities"},
    {"value": "Mental health", "label": "Mental health"},
    {"value": "Mercury", "label": "Mercury"},
    {"value": "Mercury depletion events", "label": "Mercury depletion events"},
    {"value": "Mercury speciation", "label": "Mercury speciation"},
    {"value": "Methylmercury", "label": "Methylmercury"},
    {"value": "Microbial community", "label": "Microbial community"},
    {"value": "Midwife", "label": "Midwife"},
    {"value": "Mollusc", "label": "Mollusc"},
    {"value": "Multiple chronologies", "label": "Multiple chronologies"},
    {"value": "Neurotoxin", "label": "Neurotoxin"},
    {"value": "Norovirus", "label": "Norovirus"},
    {"value": "Nunavik Public Health Direction", "label": "Nunavik Public Health Direction"},
    {"value": "Nutrition", "label": "Nutrition"},
    {"value": "Obesity", "label": "Obesity"},
    {"value": "Organophosphate flame retardants", "label": "Organophosphate flame retardants"},
    {"value": "Organophosphate plasticizers", "label": "Organophosphate plasticizers"},
    {"value": "Oxygen isotopic analysis", "label": "Oxygen isotopic analysis"},
    {"value": "Parasite", "label": "Parasite"},
    {"value": "Past climate reconstruction", "label": "Past climate reconstruction"},
    {"value": "Pathogen", "label": "Pathogen"},
    {"value": "PCBs", "label": "PCBs"},
    {"value": "PCR (polymerase chain reaction)", "label": "PCR (polymerase chain reaction)"},
    {"value": "Perfluorinated acids", "label": "Perfluorinated acids"},
    {"value": "Perfluorinated alkylated substances", "label": "Perfluorinated alkylated substances"},
    {"value": "Perfluoro contaminant", "label": "Perfluoro contaminant"},
    {"value": "Perfluorooctanesulfonate", "label": "Perfluorooctanesulfonate"},
    {"value": "Perfluorooctanoate", "label": "Perfluorooctanoate"},
    {"value": "Perinatal exposure", "label": "Perinatal exposure"},
    {"value": "Persistent organic pollutants (POPs)", "label": "Persistent organic pollutants (POPs)"},
    {"value": "Photochemistry", "label": "Photochemistry"},
    {"value": "Photodegradation", "label": "Photodegradation"},
    {"value": "Pneumonia", "label": "Pneumonia"},
    {"value": "Pregnancy", "label": "Pregnancy"},
    {"value": "Productivity", "label": "Productivity"},
    {"value": "Propylthiouracil", "label": "Propylthiouracil"},
    {"value": "Public health", "label": "Public health"},
    {"value": "Q fever", "label": "Q fever"},
    {"value": "Questionnaire", "label": "Questionnaire"},
    {"value": "Rabies", "label": "Rabies"},
    {"value": "Reactive bromide oxide", "label": "Reactive bromide oxide"},
    {"value": "Reproduction", "label": "Reproduction"},
    {"value": "Respiratory infections", "label": "Respiratory infections"},
    {"value": "Risk factor", "label": "Risk factor"},
    {"value": "Safety", "label": "Safety"},
    {"value": "Salmonella", "label": "Salmonella"},
    {"value": "Sanitation", "label": "Sanitation"},
    {"value": "Seal meat", "label": "Seal meat"},
    {"value": "Serology", "label": "Serology"},
    {"value": "Seroprevalence", "label": "Seroprevalence"},
    {"value": "Shelter", "label": "Shelter"},
    {"value": "Shigella", "label": "Shigella"},
    {"value": "Streptococcus", "label": "Streptococcus"},
    {"value": "Subsistence", "label": "Subsistence"},
    {"value": "Surveillance", "label": "Surveillance"},
    {"value": "Total gaseous mercury", "label": "Total gaseous mercury"},
    {"value": "Toxocara", "label": "Toxocara"},
    {"value": "Toxocariasis", "label": "Toxocariasis"},
    {"value": "Toxoplasma gondii", "label": "Toxoplasma gondii"},
    {"value": "Toxoplasmosis", "label": "Toxoplasmosis"},
    {"value": "Trace elements", "label": "Trace elements"},
    {"value": "Traditional diet", "label": "Traditional diet"},
    {"value": "Traditional food", "label": "Traditional food"},
    {"value": "Trail", "label": "Trail"},
    {"value": "Trans fats", "label": "Trans fats"},
    {"value": "Trends", "label": "Trends"},
    {"value": "Trichinella", "label": "Trichinella"},
    {"value": "Tularemia", "label": "Tularemia"},
    {"value": "Vaccination programs", "label": "Vaccination programs"},
    {"value": "Vaccines", "label": "Vaccines"},
    {"value": "Water quality", "label": "Water quality"},
    {"value": "Wind chill", "label": "Wind chill"},
    {"value": "Yersina", "label": "Yersina"},
    {"value": "Zoonosis", "label": "Zoonosis"},
    {"value": "Inuit Qaujimajatuqangit", "label": "Inuit Qaujimajatuqangit"},
    {"value": "Isumagijaksaq", "label": "Isumagijaksaq"},
    {"value": "Qaujisarvik", "label": "Qaujisarvik"},
    {"value": "Sila", "label": "Sila"},
    {"value": "Unikkaaqatigiit", "label": "Unikkaaqatigiit"},
    {"value": "Time-Lapse Photos", "label": "Time-Lapse Photos"},
    {"value": "137-Cs", "label": "137-Cs"},
    {"value": "210-Pb", "label": "210-Pb"},
    {"value": "AboVE", "label": "AboVE"},
    {"value": "Absorbance", "label": "Absorbance"},
    {"value": "Abundance", "label": "Abundance"},
    {"value": "Acoustic", "label": "Acoustic"},
    {"value": "Active layer", "label": "Active layer"},
    {"value": "Activity", "label": "Activity"},
    {"value": "Aerial photographs", "label": "Aerial photographs"},
    {"value": "Aerial surveys", "label": "Aerial surveys"},
    {"value": "Ahiak caribou herd", "label": "Ahiak caribou herd"},
    {"value": "Air", "label": "Air"},
    {"value": "Air gas exchange", "label": "Air gas exchange"},
    {"value": "Air temperature", "label": "Air temperature"},
    {"value": "Air-water exchange", "label": "Air-water exchange"},
    {"value": "Akia-Maniitsoq caribou herd", "label": "Akia-Maniitsoq caribou herd"},
    {"value": "Albedo", "label": "Albedo"},
    {"value": "Algae", "label": "Algae"},
    {"value": "Algal bloom", "label": "Algal bloom"},
    {"value": "Alien species", "label": "Alien species"},
    {"value": "Alkalinity", "label": "Alkalinity"},
    {"value": "Allochthonous organic matter", "label": "Allochthonous organic matter"},
    {"value": "Alpine", "label": "Alpine"},
    {"value": "American crow", "label": "American crow"},
    {"value": "Amphibians", "label": "Amphibians"},
    {"value": "Anadromous", "label": "Anadromous"},
    {"value": "Archaea", "label": "Archaea"},
    {"value": "Arctic char", "label": "Arctic char"},
    {"value": "Arctic cod", "label": "Arctic cod"},
    {"value": "Arctic fox", "label": "Arctic fox"},
    {"value": "Arctic gull", "label": "Arctic gull"},
    {"value": "Arctic Oscillation", "label": "Arctic Oscillation"},
    {"value": "Arctic wolf", "label": "Arctic wolf"},
    {"value": "Arthropods", "label": "Arthropods"},
    {"value": "Atmosphere", "label": "Atmosphere"},
    {"value": "Atmospheric composition", "label": "Atmospheric composition"},
    {"value": "Atmospheric profiler", "label": "Atmospheric profiler"},
    {"value": "Autochthonous organic matter", "label": "Autochthonous organic matter"},
    {"value": "Backscatter", "label": "Backscatter"},
    {"value": "Bacteria", "label": "Bacteria"},
    {"value": "Bacterial production", "label": "Bacterial production"},
    {"value": "Bacterivory", "label": "Bacterivory"},
    {"value": "Barometric pressure", "label": "Barometric pressure"},
    {"value": "Baseline data", "label": "Baseline data"},
    {"value": "Bathurst caribou herd", "label": "Bathurst caribou herd"},
    {"value": "Bathymetry", "label": "Bathymetry"},
    {"value": "Beavers", "label": "Beavers"},
    {"value": "Bedrock", "label": "Bedrock"},
    {"value": "Bees", "label": "Bees"},
    {"value": "Beetles", "label": "Beetles"},
    {"value": "Beluga", "label": "Beluga"},
    {"value": "Benthic surveys", "label": "Benthic surveys"},
    {"value": "Benthos", "label": "Benthos"},
    {"value": "Berries", "label": "Berries"},
    {"value": "Berry productivity", "label": "Berry productivity"},
    {"value": "Beverly caribou herd", "label": "Beverly caribou herd"},
    {"value": "Biodiversity", "label": "Biodiversity"},
    {"value": "Biogeochemistry", "label": "Biogeochemistry"},
    {"value": "Biological productivity", "label": "Biological productivity"},
    {"value": "Biological sciences", "label": "Biological sciences"},
    {"value": "Biology", "label": "Biology"},
    {"value": "Biomarkers", "label": "Biomarkers"},
    {"value": "Biomass", "label": "Biomass"},
    {"value": "Biota", "label": "Biota"},
    {"value": "Birch (Betula)", "label": "Birch (Betula)"},
    {"value": "Bird banding", "label": "Bird banding"},
    {"value": "Bird colonies", "label": "Bird colonies"},
    {"value": "Birds", "label": "Birds"},
    {"value": "Bivalves", "label": "Bivalves"},
    {"value": "Bluenose East caribou herd", "label": "Bluenose East caribou herd"},
    {"value": "Bluenose West caribou herd", "label": "Bluenose West caribou herd"},
    {"value": "Body condition", "label": "Body condition"},
    {"value": "Bottom sediments", "label": "Bottom sediments"},
    {"value": "Bouleau (Betula)", "label": "Bouleau (Betula)"},
    {"value": "Bowhead whale", "label": "Bowhead whale"},
    {"value": "Breeding", "label": "Breeding"},
    {"value": "Breeding colonies", "label": "Breeding colonies"},
    {"value": "Breeding ecology", "label": "Breeding ecology"},
    {"value": "Brightness temperature", "label": "Brightness temperature"},
    {"value": "Brine", "label": "Brine"},
    {"value": "Bromide", "label": "Bromide"},
    {"value": "Bromine oxide", "label": "Bromine oxide"},
    {"value": "Brown lemming", "label": "Brown lemming"},
    {"value": "Bryophytes", "label": "Bryophytes"},
    {"value": "Buoys", "label": "Buoys"},
    {"value": "Cackling Geese", "label": "Cackling Geese"},
    {"value": "Calving", "label": "Calving"},
    {"value": "Canada goose", "label": "Canada goose"},
    {"value": "Cape Bathurst caribou herd", "label": "Cape Bathurst caribou herd"},
    {"value": "Carbon", "label": "Carbon"},
    {"value": "Carbon dioxide", "label": "Carbon dioxide"},
    {"value": "Carbon fluxes", "label": "Carbon fluxes"},
    {"value": "Carbon lability", "label": "Carbon lability"},
    {"value": "Carbon, nitrogen and sulfur analysis (CNS)", "label": "Carbon, nitrogen and sulfur analysis (CNS)"},
    {"value": "Carbonate", "label": "Carbonate"},
    {"value": "Caribou", "label": "Caribou"},
    {"value": "Caribou demography", "label": "Caribou demography"},
    {"value": "Carnivores", "label": "Carnivores"},
    {"value": "CAT scan", "label": "CAT scan"},
    {"value": "Central Arctic caribou herd", "label": "Central Arctic caribou herd"},
    {"value": "Changements climatiques", "label": "Changements climatiques"},
    {"value": "Char", "label": "Char"},
    {"value": "Characteristic transport distance", "label": "Characteristic transport distance"},
    {"value": "Chart", "label": "Chart"},
    {"value": "Chemistry", "label": "Chemistry"},
    {"value": "Chironomids", "label": "Chironomids"},
    {"value": "Chloride", "label": "Chloride"},
    {"value": "Chlorophyll", "label": "Chlorophyll"},
    {"value": "Chokotka caribou herd", "label": "Chokotka caribou herd"},
    {"value": "Cicatrices de piétinement", "label": "Cicatrices de piétinement"},
    {"value": "Circulation", "label": "Circulation"},
    {"value": "Cladocera", "label": "Cladocera"},
    {"value": "Clay", "label": "Clay"},
    {"value": "Climate", "label": "Climate"},
    {"value": "Climate change", "label": "Climate change"},
    {"value": "Climate hazards", "label": "Climate hazards"},
    {"value": "Climate history", "label": "Climate history"},
    {"value": "Climatic models", "label": "Climatic models"},
    {"value": "Climatology", "label": "Climatology"},
    {"value": "Clone library", "label": "Clone library"},
    {"value": "Cloudbase height", "label": "Cloudbase height"},
    {"value": "Clouds", "label": "Clouds"},
    {"value": "Coastal dynamics", "label": "Coastal dynamics"},
    {"value": "Coastal erosion", "label": "Coastal erosion"},
    {"value": "Coastal hazards", "label": "Coastal hazards"},
    {"value": "Coastal ice", "label": "Coastal ice"},
    {"value": "Coastline", "label": "Coastline"},
    {"value": "Cod", "label": "Cod"},
    {"value": "Cold Regions Hydrological Model (CRHM)", "label": "Cold Regions Hydrological Model (CRHM)"},
    {"value": "Collared lemming", "label": "Collared lemming"},
    {"value": "Collembola", "label": "Collembola"},
    {"value": "Colored dissolved organic material (CDOM)", "label": "Colored dissolved organic material (CDOM)"},
    {"value": "Common eider", "label": "Common eider"},
    {"value": "Common murre", "label": "Common murre"},
    {"value": "Common raven", "label": "Common raven"},
    {"value": "Community ecology", "label": "Community ecology"},
    {"value": "Community-based monitoring", "label": "Community-based monitoring"},
    {"value": "Conduction", "label": "Conduction"},
    {"value": "Conductivity", "label": "Conductivity"},
    {"value": "Conifers", "label": "Conifers"},
    {"value": "Contaminants", "label": "Contaminants"},
    {"value": "Convection", "label": "Convection"},
    {"value": "Copepods", "label": "Copepods"},
    {"value": "Corals", "label": "Corals"},
    {"value": "Couvert nival", "label": "Couvert nival"},
    {"value": "Crab", "label": "Crab"},
    {"value": "Croissance arbustive", "label": "Croissance arbustive"},
    {"value": "Crustaceans", "label": "Crustaceans"},
    {"value": "Cryosphere", "label": "Cryosphere"},
    {"value": "CTD (Conductivity, Temperature, Depth)", "label": "CTD (Conductivity, Temperature, Depth)"},
    {"value": "CTD profiles", "label": "CTD profiles"},
    {"value": "Cyanobacteria", "label": "Cyanobacteria"},
    {"value": "Daphnia", "label": "Daphnia"},
    {"value": "Database", "label": "Database"},
    {"value": "Decomposition", "label": "Decomposition"},
    {"value": "Deep water", "label": "Deep water"},
    {"value": "Deer", "label": "Deer"},
    {"value": "Deglaciation", "label": "Deglaciation"},
    {"value": "Delta", "label": "Delta"},
    {"value": "Dendrochronologie", "label": "Dendrochronologie"},
    {"value": "Dendrochronology", "label": "Dendrochronology"},
    {"value": "Density", "label": "Density"},
    {"value": "Dewpoint", "label": "Dewpoint"},
    {"value": "Diatoms", "label": "Diatoms"},
    {"value": "Dielectric", "label": "Dielectric"},
    {"value": "Diesel", "label": "Diesel"},
    {"value": "Dimethylsulfide (DMS)", "label": "Dimethylsulfide (DMS)"},
    {"value": "Dimethylsulfoniopropionate (DMSP)", "label": "Dimethylsulfoniopropionate (DMSP)"},
    {"value": "Dinoflagellate cyst", "label": "Dinoflagellate cyst"},
    {"value": "Dinoflagellates", "label": "Dinoflagellates"},
    {"value": "Diptera", "label": "Diptera"},
    {"value": "Direction finder", "label": "Direction finder"},
    {"value": "Discontinuous permafrost", "label": "Discontinuous permafrost"},
    {"value": "Dissolved inorganic carbon (DIC)", "label": "Dissolved inorganic carbon (DIC)"},
    {"value": "Dissolved organic carbon (DOC)", "label": "Dissolved organic carbon (DOC)"},
    {"value": "Dissolved organic matter (DOM)", "label": "Dissolved organic matter (DOM)"},
    {"value": "Distribution", "label": "Distribution"},
    {"value": "Disturbance", "label": "Disturbance"},
    {"value": "Diversity", "label": "Diversity"},
    {"value": "DNA", "label": "DNA"},
    {"value": "Drainage basin", "label": "Drainage basin"},
    {"value": "Drinking water", "label": "Drinking water"},
    {"value": "Dry upland heath", "label": "Dry upland heath"},
    {"value": "Décomposition", "label": "Décomposition"},
    {"value": "Earth Sciences", "label": "Earth Sciences"},
    {"value": "Eastern High Arctic Brant", "label": "Eastern High Arctic Brant"},
    {"value": "Ecology", "label": "Ecology"},
    {"value": "Ecosystem", "label": "Ecosystem"},
    {"value": "Ecosystem functions", "label": "Ecosystem functions"},
    {"value": "Ecosystem services", "label": "Ecosystem services"},
    {"value": "Ecotype", "label": "Ecotype"},
    {"value": "Eddy covariance", "label": "Eddy covariance"},
    {"value": "Eiders", "label": "Eiders"},
    {"value": "El Niño", "label": "El Niño"},
    {"value": "Elevation Change", "label": "Elevation Change"},
    {"value": "Emissions", "label": "Emissions"},
    {"value": "Emmission Excitation Matrices (EEMs)", "label": "Emmission Excitation Matrices (EEMs)"},
    {"value": "Empetrum nigrum", "label": "Empetrum nigrum"},
    {"value": "Energy balance", "label": "Energy balance"},
    {"value": "Environmental impacts", "label": "Environmental impacts"},
    {"value": "ENVISAT", "label": "ENVISAT"},
    {"value": "Epiphytes", "label": "Epiphytes"},
    {"value": "Epishelf lakes", "label": "Epishelf lakes"},
    {"value": "Ermine", "label": "Ermine"},
    {"value": "Erosion", "label": "Erosion"},
    {"value": "Estuary", "label": "Estuary"},
    {"value": "Eukaryotes", "label": "Eukaryotes"},
    {"value": "Eutrophication", "label": "Eutrophication"},
    {"value": "Experimental warming", "label": "Experimental warming"},
    {"value": "Export production", "label": "Export production"},
    {"value": "Extracellular enzymes", "label": "Extracellular enzymes"},
    {"value": "Extracellular polymeric substances", "label": "Extracellular polymeric substances"},
    {"value": "Extreme habitats", "label": "Extreme habitats"},
    {"value": "Extreme weather", "label": "Extreme weather"},
    {"value": "Extremophiles", "label": "Extremophiles"},
    {"value": "Fatty acids", "label": "Fatty acids"},
    {"value": "Fauna", "label": "Fauna"},
    {"value": "Fecundity", "label": "Fecundity"},
    {"value": "Feeding", "label": "Feeding"},
    {"value": "Feeding experiment", "label": "Feeding experiment"},
    {"value": "Feeding success", "label": "Feeding success"},
    {"value": "Femtoplankton", "label": "Femtoplankton"},
    {"value": "Fiords", "label": "Fiords"},
    {"value": "Fire", "label": "Fire"},
    {"value": "Fish larvae", "label": "Fish larvae"},
    {"value": "Fisheries", "label": "Fisheries"},
    {"value": "Fishes", "label": "Fishes"},
    {"value": "Fitness", "label": "Fitness"},
    {"value": "Flies", "label": "Flies"},
    {"value": "Flood", "label": "Flood"},
    {"value": "Flora", "label": "Flora"},
    {"value": "Flowering plants", "label": "Flowering plants"},
    {"value": "Flowers", "label": "Flowers"},
    {"value": "Fluorescence", "label": "Fluorescence"},
    {"value": "Fluorinated contaminants", "label": "Fluorinated contaminants"},
    {"value": "Fluvial", "label": "Fluvial"},
    {"value": "Flux", "label": "Flux"},
    {"value": "Fluxes", "label": "Fluxes"},
    {"value": "Food", "label": "Food"},
    {"value": "Food web", "label": "Food web"},
    {"value": "Foraminifers", "label": "Foraminifers"},
    {"value": "Forecast", "label": "Forecast"},
    {"value": "Forest-tundra", "label": "Forest-tundra"},
    {"value": "Forests", "label": "Forests"},
    {"value": "Fossils", "label": "Fossils"},
    {"value": "Foxes", "label": "Foxes"},
    {"value": "Freeze-up", "label": "Freeze-up"},
    {"value": "Frequency", "label": "Frequency"},
    {"value": "Freshwater flows", "label": "Freshwater flows"},
    {"value": "Freshwater fluxes", "label": "Freshwater fluxes"},
    {"value": "Freshwaters", "label": "Freshwaters"},
    {"value": "Frogs", "label": "Frogs"},
    {"value": "Frost flowers", "label": "Frost flowers"},
    {"value": "Fulmars", "label": "Fulmars"},
    {"value": "Fungi", "label": "Fungi"},
    {"value": "Gases", "label": "Gases"},
    {"value": "Gastropod", "label": "Gastropod"},
    {"value": "Geese", "label": "Geese"},
    {"value": "General Circulation Model", "label": "General Circulation Model"},
    {"value": "Genetic analysis", "label": "Genetic analysis"},
    {"value": "Geodetic", "label": "Geodetic"},
    {"value": "Geohazard", "label": "Geohazard"},
    {"value": "Geology", "label": "Geology"},
    {"value": "Geomorphology", "label": "Geomorphology"},
    {"value": "Geophysical surveys", "label": "Geophysical surveys"},
    {"value": "George River caribou herd", "label": "George River caribou herd"},
    {"value": "Geospatial data", "label": "Geospatial data"},
    {"value": "GIS", "label": "GIS"},
    {"value": "Glacial runoff", "label": "Glacial runoff"},
    {"value": "Glaciers", "label": "Glaciers"},
    {"value": "Glaciology", "label": "Glaciology"},
    {"value": "Glaucous gull", "label": "Glaucous gull"},
    {"value": "Goose", "label": "Goose"},
    {"value": "GPS", "label": "GPS"},
    {"value": "Gradients", "label": "Gradients"},
    {"value": "Grain size", "label": "Grain size"},
    {"value": "Graines", "label": "Graines"},
    {"value": "Graminoids", "label": "Graminoids"},
    {"value": "Grass", "label": "Grass"},
    {"value": "Gravity processes", "label": "Gravity processes"},
    {"value": "Grazing", "label": "Grazing"},
    {"value": "Grazing impacts", "label": "Grazing impacts"},
    {"value": "Greater snow geese", "label": "Greater snow geese"},
    {"value": "Greenhouse gas", "label": "Greenhouse gas"},
    {"value": "Greenland shark", "label": "Greenland shark"},
    {"value": "Grizzly bear", "label": "Grizzly bear"},
    {"value": "Ground ice", "label": "Ground ice"},
    {"value": "Ground penetrating radar", "label": "Ground penetrating radar"},
    {"value": "Ground surveys", "label": "Ground surveys"},
    {"value": "Ground temperature", "label": "Ground temperature"},
    {"value": "Groundwater", "label": "Groundwater"},
    {"value": "Grouse", "label": "Grouse"},
    {"value": "Growth rate", "label": "Growth rate"},
    {"value": "Guillemots", "label": "Guillemots"},
    {"value": "Gull", "label": "Gull"},
    {"value": "Gulls", "label": "Gulls"},
    {"value": "Gut content analyses", "label": "Gut content analyses"},
    {"value": "Habitat use", "label": "Habitat use"},
    {"value": "Habitats", "label": "Habitats"},
    {"value": "Halibuts", "label": "Halibuts"},
    {"value": "Hardangaarvida caribou herd", "label": "Hardangaarvida caribou herd"},
    {"value": "Hares", "label": "Hares"},
    {"value": "Heat", "label": "Heat"},
    {"value": "Heat budget", "label": "Heat budget"},
    {"value": "Heat fluxes", "label": "Heat fluxes"},
    {"value": "Herbivores", "label": "Herbivores"},
    {"value": "Herbivory", "label": "Herbivory"},
    {"value": "Herring gull", "label": "Herring gull"},
    {"value": "Heterotrophy", "label": "Heterotrophy"},
    {"value": "Holocene", "label": "Holocene"},
    {"value": "Horizontal gene transfer", "label": "Horizontal gene transfer"},
    {"value": "Humidity", "label": "Humidity"},
    {"value": "Hydrochemistry", "label": "Hydrochemistry"},
    {"value": "Hydroelectric reservoir", "label": "Hydroelectric reservoir"},
    {"value": "Hydroelectricity", "label": "Hydroelectricity"},
    {"value": "Hydrography", "label": "Hydrography"},
    {"value": "Hydrology", "label": "Hydrology"},
    {"value": "Ice", "label": "Ice"},
    {"value": "Ice algae", "label": "Ice algae"},
    {"value": "Ice break-up", "label": "Ice break-up"},
    {"value": "Ice chart", "label": "Ice chart"},
    {"value": "Ice cores", "label": "Ice cores"},
    {"value": "Ice drift", "label": "Ice drift"},
    {"value": "Ice island", "label": "Ice island"},
    {"value": "Ice margin", "label": "Ice margin"},
    {"value": "Ice microstructure", "label": "Ice microstructure"},
    {"value": "Ice pack motion", "label": "Ice pack motion"},
    {"value": "Ice patch", "label": "Ice patch"},
    {"value": "Ice shelf", "label": "Ice shelf"},
    {"value": "Ice thickness", "label": "Ice thickness"},
    {"value": "Ice wedges", "label": "Ice wedges"},
    {"value": "Iceberg", "label": "Iceberg"},
    {"value": "Iceland caribou herd", "label": "Iceland caribou herd"},
    {"value": "Ichthyoplankton", "label": "Ichthyoplankton"},
    {"value": "Ikonos", "label": "Ikonos"},
    {"value": "Image analysis", "label": "Image analysis"},
    {"value": "Imagery", "label": "Imagery"},
    {"value": "Images", "label": "Images"},
    {"value": "Indicators", "label": "Indicators"},
    {"value": "Infrared", "label": "Infrared"},
    {"value": "Infrastructures", "label": "Infrastructures"},
    {"value": "Ingestion rates", "label": "Ingestion rates"},
    {"value": "Insects", "label": "Insects"},
    {"value": "Integrated Regional Impact Studies", "label": "Integrated Regional Impact Studies"},
    {"value": "Inter-specific relationships", "label": "Inter-specific relationships"},
    {"value": "Interflow", "label": "Interflow"},
    {"value": "Invasive species", "label": "Invasive species"},
    {"value": "Invertebrates", "label": "Invertebrates"},
    {"value": "Ions concentration", "label": "Ions concentration"},
    {"value": "Isotopes", "label": "Isotopes"},
    {"value": "ITRAX", "label": "ITRAX"},
    {"value": "Jaegers", "label": "Jaegers"},
    {"value": "JPEG", "label": "JPEG"},
    {"value": "Kangerlussuaq-Sisimiut caribou herd", "label": "Kangerlussuaq-Sisimiut caribou herd"},
    {"value": "Kemmerer water sampler", "label": "Kemmerer water sampler"},
    {"value": "Keystone species", "label": "Keystone species"},
    {"value": "Killer whale", "label": "Killer whale"},
    {"value": "Lake", "label": "Lake"},
    {"value": "Lake ice", "label": "Lake ice"},
    {"value": "Lake sediments", "label": "Lake sediments"},
    {"value": "Lake trout", "label": "Lake trout"},
    {"value": "Lake water turbidity", "label": "Lake water turbidity"},
    {"value": "Lakes", "label": "Lakes"},
    {"value": "Land cover", "label": "Land cover"},
    {"value": "Land Surface Temperature", "label": "Land Surface Temperature"},
    {"value": "Land-water interface", "label": "Land-water interface"},
    {"value": "Landfast ice", "label": "Landfast ice"},
    {"value": "Landform", "label": "Landform"},
    {"value": "Landsat image", "label": "Landsat image"},
    {"value": "Landscape", "label": "Landscape"},
    {"value": "Landslide", "label": "Landslide"},
    {"value": "Lapland longspur", "label": "Lapland longspur"},
    {"value": "Larval fishes", "label": "Larval fishes"},
    {"value": "Laser", "label": "Laser"},
    {"value": "Leads", "label": "Leads"},
    {"value": "Leaf River caribou herd", "label": "Leaf River caribou herd"},
    {"value": "Lemmings", "label": "Lemmings"},
    {"value": "Lena-Olenyk caribou herd", "label": "Lena-Olenyk caribou herd"},
    {"value": "Lepidoptera", "label": "Lepidoptera"},
    {"value": "Lesser snow geese", "label": "Lesser snow geese"},
    {"value": "Lichens", "label": "Lichens"},
    {"value": "LiDAR", "label": "LiDAR"},
    {"value": "Life history", "label": "Life history"},
    {"value": "Lignin", "label": "Lignin"},
    {"value": "Limite des arbres", "label": "Limite des arbres"},
    {"value": "Limnology", "label": "Limnology"},
    {"value": "Liquid chromatography", "label": "Liquid chromatography"},
    {"value": "Litter size", "label": "Litter size"},
    {"value": "Long-tailed jaeger", "label": "Long-tailed jaeger"},
    {"value": "Loons", "label": "Loons"},
    {"value": "Loss on ignition (LOI)", "label": "Loss on ignition (LOI)"},
    {"value": "Lungworm", "label": "Lungworm"},
    {"value": "Macrophytes", "label": "Macrophytes"},
    {"value": "Macrozoobenthos", "label": "Macrozoobenthos"},
    {"value": "Malaise traps", "label": "Malaise traps"},
    {"value": "Mammals", "label": "Mammals"},
    {"value": "Map layers", "label": "Map layers"},
    {"value": "Mapping", "label": "Mapping"},
    {"value": "Maps", "label": "Maps"},
    {"value": "Marine birds", "label": "Marine birds"},
    {"value": "Marine ecology", "label": "Marine ecology"},
    {"value": "Marine mammals", "label": "Marine mammals"},
    {"value": "Marine productivity", "label": "Marine productivity"},
    {"value": "Marine sediments", "label": "Marine sediments"},
    {"value": "Mass Balance", "label": "Mass Balance"},
    {"value": "Mass movements", "label": "Mass movements"},
    {"value": "Mass spectrometry", "label": "Mass spectrometry"},
    {"value": "Megazoobenthos", "label": "Megazoobenthos"},
    {"value": "Meltpond", "label": "Meltpond"},
    {"value": "Meltpond fraction", "label": "Meltpond fraction"},
    {"value": "Mercury fluxes", "label": "Mercury fluxes"},
    {"value": "Mesic tundra", "label": "Mesic tundra"},
    {"value": "Metadata", "label": "Metadata"},
    {"value": "Metals", "label": "Metals"},
    {"value": "Meteorological", "label": "Meteorological"},
    {"value": "Meteorology", "label": "Meteorology"},
    {"value": "Methane", "label": "Methane"},
    {"value": "Methanesulphonate", "label": "Methanesulphonate"},
    {"value": "Microarray", "label": "Microarray"},
    {"value": "Microbial food webs", "label": "Microbial food webs"},
    {"value": "Microbial methylation", "label": "Microbial methylation"},
    {"value": "Microfossils", "label": "Microfossils"},
    {"value": "Microorganisms", "label": "Microorganisms"},
    {"value": "Microplastics", "label": "Microplastics"},
    {"value": "Microwave", "label": "Microwave"},
    {"value": "Microzooplankton", "label": "Microzooplankton"},
    {"value": "Migration", "label": "Migration"},
    {"value": "Migratory routes", "label": "Migratory routes"},
    {"value": "Mineralogy", "label": "Mineralogy"},
    {"value": "Mines", "label": "Mines"},
    {"value": "MOBS", "label": "MOBS"},
    {"value": "Modeling", "label": "Modeling"},
    {"value": "Models", "label": "Models"},
    {"value": "MODIS", "label": "MODIS"},
    {"value": "Molecular biogeochemistry", "label": "Molecular biogeochemistry"},
    {"value": "Molluscs", "label": "Molluscs"},
    {"value": "Momentum fluxes", "label": "Momentum fluxes"},
    {"value": "Monitoring", "label": "Monitoring"},
    {"value": "Mooring", "label": "Mooring"},
    {"value": "Moose", "label": "Moose"},
    {"value": "Morphology", "label": "Morphology"},
    {"value": "Mosquitos", "label": "Mosquitos"},
    {"value": "Moss", "label": "Moss"},
    {"value": "Motion", "label": "Motion"},
    {"value": "Movement", "label": "Movement"},
    {"value": "Multibeam", "label": "Multibeam"},
    {"value": "Murres", "label": "Murres"},
    {"value": "Muskoxen", "label": "Muskoxen"},
    {"value": "Mussels", "label": "Mussels"},
    {"value": "Nanoflagellates", "label": "Nanoflagellates"},
    {"value": "Narwhals", "label": "Narwhals"},
    {"value": "NASA", "label": "NASA"},
    {"value": "Natural radionuclides", "label": "Natural radionuclides"},
    {"value": "Nepheloid layer", "label": "Nepheloid layer"},
    {"value": "Nesting", "label": "Nesting"},
    {"value": "New production", "label": "New production"},
    {"value": "Nitrates", "label": "Nitrates"},
    {"value": "Nitrogen", "label": "Nitrogen"},
    {"value": "Nitrous oxide (N2O)", "label": "Nitrous oxide (N2O)"},
    {"value": "Nuclear magnetic resonance", "label": "Nuclear magnetic resonance"},
    {"value": "Nutrient availability", "label": "Nutrient availability"},
    {"value": "Nutrient cycling", "label": "Nutrient cycling"},
    {"value": "Nutrient inputs", "label": "Nutrient inputs"},
    {"value": "Nutrients", "label": "Nutrients"},
    {"value": "Observatory", "label": "Observatory"},
    {"value": "Ocean acidification", "label": "Ocean acidification"},
    {"value": "Ocean circulation", "label": "Ocean circulation"},
    {"value": "Ocean currents", "label": "Ocean currents"},
    {"value": "Oceanic water masses", "label": "Oceanic water masses"},
    {"value": "Oceanography", "label": "Oceanography"},
    {"value": "Oceans", "label": "Oceans"},
    {"value": "Omnitrax", "label": "Omnitrax"},
    {"value": "Optical", "label": "Optical"},
    {"value": "Optics", "label": "Optics"},
    {"value": "Organic carbon", "label": "Organic carbon"},
    {"value": "Organic matter", "label": "Organic matter"},
    {"value": "Organic microfossils", "label": "Organic microfossils"},
    {"value": "Organohalogens", "label": "Organohalogens"},
    {"value": "Ostracods", "label": "Ostracods"},
    {"value": "Otolith", "label": "Otolith"},
    {"value": "Otoliths", "label": "Otoliths"},
    {"value": "Ouranos", "label": "Ouranos"},
    {"value": "Outbreak", "label": "Outbreak"},
    {"value": "Overflow", "label": "Overflow"},
    {"value": "Oxygen", "label": "Oxygen"},
    {"value": "Oxygen isotopes", "label": "Oxygen isotopes"},
    {"value": "Ozone", "label": "Ozone"},
    {"value": "Paleo-indicators", "label": "Paleo-indicators"},
    {"value": "Paleoceanography", "label": "Paleoceanography"},
    {"value": "Paleoclimate", "label": "Paleoclimate"},
    {"value": "Paleoclimatic reconstruction", "label": "Paleoclimatic reconstruction"},
    {"value": "Paleoecology", "label": "Paleoecology"},
    {"value": "Paleoenvironment", "label": "Paleoenvironment"},
    {"value": "Paleolimnology", "label": "Paleolimnology"},
    {"value": "Paleomagnetism", "label": "Paleomagnetism"},
    {"value": "Palsa", "label": "Palsa"},
    {"value": "Parasites", "label": "Parasites"},
    {"value": "Parasitic jaeger", "label": "Parasitic jaeger"},
    {"value": "Particles", "label": "Particles"},
    {"value": "Particulate inorganic carbon", "label": "Particulate inorganic carbon"},
    {"value": "Particulate organic carbon", "label": "Particulate organic carbon"},
    {"value": "Passerines", "label": "Passerines"},
    {"value": "Passive microwave", "label": "Passive microwave"},
    {"value": "Pathfinder", "label": "Pathfinder"},
    {"value": "Peary caribou", "label": "Peary caribou"},
    {"value": "Peat", "label": "Peat"},
    {"value": "Peat cores", "label": "Peat cores"},
    {"value": "Peat cover", "label": "Peat cover"},
    {"value": "Peatland", "label": "Peatland"},
    {"value": "Peregrine falcon", "label": "Peregrine falcon"},
    {"value": "Perennial ice", "label": "Perennial ice"},
    {"value": "Periphyton", "label": "Periphyton"},
    {"value": "Permafrost", "label": "Permafrost"},
    {"value": "Pesticides", "label": "Pesticides"},
    {"value": "pH", "label": "pH"},
    {"value": "Phenology", "label": "Phenology"},
    {"value": "Phosphorus", "label": "Phosphorus"},
    {"value": "Photo-oxidation", "label": "Photo-oxidation"},
    {"value": "Photoprotection", "label": "Photoprotection"},
    {"value": "Photosynthesis", "label": "Photosynthesis"},
    {"value": "Photosynthetically available radiation (PAR)", "label": "Photosynthetically available radiation (PAR)"},
    {"value": "Physical forcing", "label": "Physical forcing"},
    {"value": "Physical-biological coupling", "label": "Physical-biological coupling"},
    {"value": "Phytoplankton", "label": "Phytoplankton"},
    {"value": "Phytoplankton viability", "label": "Phytoplankton viability"},
    {"value": "Picea glauca", "label": "Picea glauca"},
    {"value": "Picocyanobacteria", "label": "Picocyanobacteria"},
    {"value": "Picoeukaryotes", "label": "Picoeukaryotes"},
    {"value": "Picoplankton", "label": "Picoplankton"},
    {"value": "Pictures", "label": "Pictures"},
    {"value": "Pigments", "label": "Pigments"},
    {"value": "Pipeline", "label": "Pipeline"},
    {"value": "Plant biomass", "label": "Plant biomass"},
    {"value": "Plant colonization", "label": "Plant colonization"},
    {"value": "Plant succession", "label": "Plant succession"},
    {"value": "Plants", "label": "Plants"},
    {"value": "Plastics", "label": "Plastics"},
    {"value": "Plovers", "label": "Plovers"},
    {"value": "Polar bear", "label": "Polar bear"},
    {"value": "Polar desert", "label": "Polar desert"},
    {"value": "Polarization", "label": "Polarization"},
    {"value": "Polarized light", "label": "Polarized light"},
    {"value": "Pollen", "label": "Pollen"},
    {"value": "Polygonal terrain", "label": "Polygonal terrain"},
    {"value": "Polymers", "label": "Polymers"},
    {"value": "Polynya", "label": "Polynya"},
    {"value": "Ponds", "label": "Ponds"},
    {"value": "Population dynamics", "label": "Population dynamics"},
    {"value": "Populations", "label": "Populations"},
    {"value": "Porcupine caribou herd", "label": "Porcupine caribou herd"},
    {"value": "Post-glacial uplift", "label": "Post-glacial uplift"},
    {"value": "Precipitation", "label": "Precipitation"},
    {"value": "Predation", "label": "Predation"},
    {"value": "Predation impacts", "label": "Predation impacts"},
    {"value": "Predator-prey interactions", "label": "Predator-prey interactions"},
    {"value": "Pressure", "label": "Pressure"},
    {"value": "Primary production", "label": "Primary production"},
    {"value": "Priming effect", "label": "Priming effect"},
    {"value": "Profiler", "label": "Profiler"},
    {"value": "Protists", "label": "Protists"},
    {"value": "Protostrongylidae", "label": "Protostrongylidae"},
    {"value": "Qamanirjuaq caribou herd", "label": "Qamanirjuaq caribou herd"},
    {"value": "Quaternary", "label": "Quaternary"},
    {"value": "Radar", "label": "Radar"},
    {"value": "RADARSAT", "label": "RADARSAT"},
    {"value": "Radial growth", "label": "Radial growth"},
    {"value": "Radiation", "label": "Radiation"},
    {"value": "Radio scattering", "label": "Radio scattering"},
    {"value": "Radio telemetry", "label": "Radio telemetry"},
    {"value": "Radiochronology", "label": "Radiochronology"},
    {"value": "Radiometer", "label": "Radiometer"},
    {"value": "Radiometric dating", "label": "Radiometric dating"},
    {"value": "Raptors", "label": "Raptors"},
    {"value": "Rare Earth Elements", "label": "Rare Earth Elements"},
    {"value": "Red fox", "label": "Red fox"},
    {"value": "Regional variations", "label": "Regional variations"},
    {"value": "Reindeer", "label": "Reindeer"},
    {"value": "Relative humidity", "label": "Relative humidity"},
    {"value": "Remote sensing data", "label": "Remote sensing data"},
    {"value": "Renewable", "label": "Renewable"},
    {"value": "Reproductive ecology", "label": "Reproductive ecology"},
    {"value": "Reproductive phenology", "label": "Reproductive phenology"},
    {"value": "Reproductive success", "label": "Reproductive success"},
    {"value": "Reptiles", "label": "Reptiles"},
    {"value": "Resistivity", "label": "Resistivity"},
    {"value": "Resolution", "label": "Resolution"},
    {"value": "Resources", "label": "Resources"},
    {"value": "Respiration", "label": "Respiration"},
    {"value": "Retrogressive thaw slump", "label": "Retrogressive thaw slump"},
    {"value": "Ridges", "label": "Ridges"},
    {"value": "Ringed seal", "label": "Ringed seal"},
    {"value": "River", "label": "River"},
    {"value": "River ice", "label": "River ice"},
    {"value": "River water turbidity", "label": "River water turbidity"},
    {"value": "Rivers", "label": "Rivers"},
    {"value": "RNA", "label": "RNA"},
    {"value": "Rock Eval pyrolysis", "label": "Rock Eval pyrolysis"},
    {"value": "Rodents", "label": "Rodents"},
    {"value": "Rough-legged hawk", "label": "Rough-legged hawk"},
    {"value": "Roughness", "label": "Roughness"},
    {"value": "RSF function", "label": "RSF function"},
    {"value": "Réservoirs hydro-électriques", "label": "Réservoirs hydro-électriques"},
    {"value": "Salinity", "label": "Salinity"},
    {"value": "Salmons", "label": "Salmons"},
    {"value": "Salt rejection", "label": "Salt rejection"},
    {"value": "Sandpipers", "label": "Sandpipers"},
    {"value": "SAR", "label": "SAR"},
    {"value": "Satellite imagery", "label": "Satellite imagery"},
    {"value": "Satellite validation", "label": "Satellite validation"},
    {"value": "Scanning electron microscope (SEM)", "label": "Scanning electron microscope (SEM)"},
    {"value": "Scatterometer", "label": "Scatterometer"},
    {"value": "Scenarios", "label": "Scenarios"},
    {"value": "Sculpins", "label": "Sculpins"},
    {"value": "Sea birds", "label": "Sea birds"},
    {"value": "Sea ice", "label": "Sea ice"},
    {"value": "Sea level", "label": "Sea level"},
    {"value": "Seabed", "label": "Seabed"},
    {"value": "Seals", "label": "Seals"},
    {"value": "Seawater", "label": "Seawater"},
    {"value": "Secondary production", "label": "Secondary production"},
    {"value": "Sedge meadow", "label": "Sedge meadow"},
    {"value": "Sediment accumulation rate", "label": "Sediment accumulation rate"},
    {"value": "Sediment cores", "label": "Sediment cores"},
    {"value": "Sediment fluxes", "label": "Sediment fluxes"},
    {"value": "Sedimentation rates", "label": "Sedimentation rates"},
    {"value": "Sediments", "label": "Sediments"},
    {"value": "Seeds", "label": "Seeds"},
    {"value": "Sheep", "label": "Sheep"},
    {"value": "Shorebirds", "label": "Shorebirds"},
    {"value": "Shoreline", "label": "Shoreline"},
    {"value": "Short-eared owl", "label": "Short-eared owl"},
    {"value": "Shrimps", "label": "Shrimps"},
    {"value": "Shrub competition", "label": "Shrub competition"},
    {"value": "Shrub growth", "label": "Shrub growth"},
    {"value": "Shrubification", "label": "Shrubification"},
    {"value": "Shrubs", "label": "Shrubs"},
    {"value": "Significant wave height", "label": "Significant wave height"},
    {"value": "Silica", "label": "Silica"},
    {"value": "Slope", "label": "Slope"},
    {"value": "Small mammals", "label": "Small mammals"},
    {"value": "Snow", "label": "Snow"},
    {"value": "Snow accumulation rates", "label": "Snow accumulation rates"},
    {"value": "Snow cover", "label": "Snow cover"},
    {"value": "Snow density", "label": "Snow density"},
    {"value": "Snow depth", "label": "Snow depth"},
    {"value": "Snow fence", "label": "Snow fence"},
    {"value": "Snow geese", "label": "Snow geese"},
    {"value": "Snow manipulation", "label": "Snow manipulation"},
    {"value": "Snow melt", "label": "Snow melt"},
    {"value": "Snow Pit", "label": "Snow Pit"},
    {"value": "Snow profile", "label": "Snow profile"},
    {"value": "Snow temperature", "label": "Snow temperature"},
    {"value": "Snow water equivalent (SWE)", "label": "Snow water equivalent (SWE)"},
    {"value": "Snowy owl", "label": "Snowy owl"},
    {"value": "Social-ecological systems", "label": "Social-ecological systems"},
    {"value": "Soil chemistry", "label": "Soil chemistry"},
    {"value": "Soil microbial biomass", "label": "Soil microbial biomass"},
    {"value": "Soil microbiology", "label": "Soil microbiology"},
    {"value": "Soil moisture", "label": "Soil moisture"},
    {"value": "Soil pH", "label": "Soil pH"},
    {"value": "Soil temperature", "label": "Soil temperature"},
    {"value": "Soils", "label": "Soils"},
    {"value": "Solar radiation", "label": "Solar radiation"},
    {"value": "Solute", "label": "Solute"},
    {"value": "Southampton caribou herd", "label": "Southampton caribou herd"},
    {"value": "Southern Oscillation", "label": "Southern Oscillation"},
    {"value": "Spatial data", "label": "Spatial data"},
    {"value": "Spatial Distribution", "label": "Spatial Distribution"},
    {"value": "Species composition", "label": "Species composition"},
    {"value": "Spiders", "label": "Spiders"},
    {"value": "Sponges", "label": "Sponges"},
    {"value": "Spores", "label": "Spores"},
    {"value": "Stable isotope analyses", "label": "Stable isotope analyses"},
    {"value": "Stable isotope tracers", "label": "Stable isotope tracers"},
    {"value": "Stamukhi", "label": "Stamukhi"},
    {"value": "Statistics", "label": "Statistics"},
    {"value": "Stomach contents", "label": "Stomach contents"},
    {"value": "Storm surge", "label": "Storm surge"},
    {"value": "Storms", "label": "Storms"},
    {"value": "Stratification", "label": "Stratification"},
    {"value": "Stratigraphy", "label": "Stratigraphy"},
    {"value": "Stream", "label": "Stream"},
    {"value": "Stream enhancement", "label": "Stream enhancement"},
    {"value": "Stream flow", "label": "Stream flow"},
    {"value": "Sub-bottom profiler", "label": "Sub-bottom profiler"},
    {"value": "Sulphate reduction", "label": "Sulphate reduction"},
    {"value": "Sulphur", "label": "Sulphur"},
    {"value": "Summer melt", "label": "Summer melt"},
    {"value": "Surface", "label": "Surface"},
    {"value": "Surface ozone depletion", "label": "Surface ozone depletion"},
    {"value": "Surface sediments", "label": "Surface sediments"},
    {"value": "Surface water runoff", "label": "Surface water runoff"},
    {"value": "Surficial deposit", "label": "Surficial deposit"},
    {"value": "Suspended sediments", "label": "Suspended sediments"},
    {"value": "Sustainability", "label": "Sustainability"},
    {"value": "Svalbard caribou herd", "label": "Svalbard caribou herd"},
    {"value": "Swans", "label": "Swans"},
    {"value": "Sympagic meiofauna", "label": "Sympagic meiofauna"},
    {"value": "Taimyr caribou herd", "label": "Taimyr caribou herd"},
    {"value": "Talus", "label": "Talus"},
    {"value": "Target strength", "label": "Target strength"},
    {"value": "Taux de croissance", "label": "Taux de croissance"},
    {"value": "Taxonomy", "label": "Taxonomy"},
    {"value": "Telemetry", "label": "Telemetry"},
    {"value": "Temperature", "label": "Temperature"},
    {"value": "Température du sol", "label": "Température du sol"},
    {"value": "Terrestrial ecosystem", "label": "Terrestrial ecosystem"},
    {"value": "Territories", "label": "Territories"},
    {"value": "Teshekpuk Lake caribou herd", "label": "Teshekpuk Lake caribou herd"},
    {"value": "test", "label": "test"},
    {"value": "Thaw lakes", "label": "Thaw lakes"},
    {"value": "Thawing", "label": "Thawing"},
    {"value": "Thermo-erosion gullies", "label": "Thermo-erosion gullies"},
    {"value": "Thermodynamics", "label": "Thermodynamics"},
    {"value": "Thermokarst", "label": "Thermokarst"},
    {"value": "Thick-billed murre", "label": "Thick-billed murre"},
    {"value": "Thin section", "label": "Thin section"},
    {"value": "Threatened", "label": "Threatened"},
    {"value": "Threshold", "label": "Threshold"},
    {"value": "Tides", "label": "Tides"},
    {"value": "Topogram", "label": "Topogram"},
    {"value": "Topographic map", "label": "Topographic map"},
    {"value": "Topographical surveys", "label": "Topographical surveys"},
    {"value": "Topography", "label": "Topography"},
    {"value": "Transducer", "label": "Transducer"},
    {"value": "Transect", "label": "Transect"},
    {"value": "Transmittance", "label": "Transmittance"},
    {"value": "Transpolar drift", "label": "Transpolar drift"},
    {"value": "Traps", "label": "Traps"},
    {"value": "Treeline", "label": "Treeline"},
    {"value": "Trees", "label": "Trees"},
    {"value": "Trophic dynamics", "label": "Trophic dynamics"},
    {"value": "Tropopause", "label": "Tropopause"},
    {"value": "Tropospheric mercury", "label": "Tropospheric mercury"},
    {"value": "Tundra", "label": "Tundra"},
    {"value": "Turbidity", "label": "Turbidity"},
    {"value": "Turbulence", "label": "Turbulence"},
    {"value": "Turbulent fluxes", "label": "Turbulent fluxes"},
    {"value": "Ultraviolet radiation", "label": "Ultraviolet radiation"},
    {"value": "Underflow", "label": "Underflow"},
    {"value": "Ungulates", "label": "Ungulates"},
    {"value": "Upwelling", "label": "Upwelling"},
    {"value": "Vaccinium uliginosum", "label": "Vaccinium uliginosum"},
    {"value": "Varve", "label": "Varve"},
    {"value": "Vascular plants", "label": "Vascular plants"},
    {"value": "Vegetation", "label": "Vegetation"},
    {"value": "Velocity", "label": "Velocity"},
    {"value": "Vertical distribution", "label": "Vertical distribution"},
    {"value": "Viabilité des graines", "label": "Viabilité des graines"},
    {"value": "Virus", "label": "Virus"},
    {"value": "Voles", "label": "Voles"},
    {"value": "Végétation", "label": "Végétation"},
    {"value": "Walrus", "label": "Walrus"},
    {"value": "Water", "label": "Water"},
    {"value": "Water balance", "label": "Water balance"},
    {"value": "Water budget", "label": "Water budget"},
    {"value": "Water chemistry", "label": "Water chemistry"},
    {"value": "Water column", "label": "Water column"},
    {"value": "Water density", "label": "Water density"},
    {"value": "Water level", "label": "Water level"},
    {"value": "Water supply", "label": "Water supply"},
    {"value": "Water temperature", "label": "Water temperature"},
    {"value": "Water tracks", "label": "Water tracks"},
    {"value": "Water vapour flux", "label": "Water vapour flux"},
    {"value": "Water-air gas exchange", "label": "Water-air gas exchange"},
    {"value": "Waterfowl", "label": "Waterfowl"},
    {"value": "Watershed", "label": "Watershed"},
    {"value": "Wave parameters", "label": "Wave parameters"},
    {"value": "Wave spectrum", "label": "Wave spectrum"},
    {"value": "Waves", "label": "Waves"},
    {"value": "Weasels", "label": "Weasels"},
    {"value": "Weather", "label": "Weather"},
    {"value": "Webcam", "label": "Webcam"},
    {"value": "Western Arctic caribou herd", "label": "Western Arctic caribou herd"},
    {"value": "Wetland", "label": "Wetland"},
    {"value": "Whales", "label": "Whales"},
    {"value": "White spruce", "label": "White spruce"},
    {"value": "White-rumped sandpiper", "label": "White-rumped sandpiper"},
    {"value": "Wildlife", "label": "Wildlife"},
    {"value": "Wildlife management", "label": "Wildlife management"},
    {"value": "Willow (Salix)", "label": "Willow (Salix)"},
    {"value": "Wind direction", "label": "Wind direction"},
    {"value": "Wind speed", "label": "Wind speed"},
    {"value": "Winds", "label": "Winds"},
    {"value": "Wolverine", "label": "Wolverine"},
    {"value": "Wolves", "label": "Wolves"},
    {"value": "X-radiography", "label": "X-radiography"},
    {"value": "Yukon Dolly Varden charr", "label": "Yukon Dolly Varden charr"},
    {"value": "Zoobenthos", "label": "Zoobenthos"},
    {"value": "Zoology", "label": "Zoology"},
    {"value": "Zooplankton", "label": "Zooplankton"},
    {"value": "Écotone forêt-toundra", "label": "Écotone forêt-toundra"},
    {"value": "Établissement de plantules", "label": "Établissement de plantules"},
    {"value": "Aklavik", "label": "Aklavik"},
    {"value": "Akulivik", "label": "Akulivik"},
    {"value": "Alert", "label": "Alert"},
    {"value": "Arctic Bay", "label": "Arctic Bay"},
    {"value": "Arviat", "label": "Arviat"},
    {"value": "Aupaluk", "label": "Aupaluk"},
    {"value": "Baker Lake", "label": "Baker Lake"},
    {"value": "Bathurst Inlet", "label": "Bathurst Inlet"},
    {"value": "Bay Chimo", "label": "Bay Chimo"},
    {"value": "Cambridge Bay", "label": "Cambridge Bay"},
    {"value": "Cape Dorset", "label": "Cape Dorset"},
    {"value": "Chesterfield Inlet", "label": "Chesterfield Inlet"},
    {"value": "Churchill Falls", "label": "Churchill Falls"},
    {"value": "Clyde River", "label": "Clyde River"},
    {"value": "Colville Lake", "label": "Colville Lake"},
    {"value": "Coral Harbour", "label": "Coral Harbour"},
    {"value": "Davis Inlet", "label": "Davis Inlet"},
    {"value": "Deline", "label": "Deline"},
    {"value": "Eureka", "label": "Eureka"},
    {"value": "Fort Good Hope", "label": "Fort Good Hope"},
    {"value": "Fort McPherson", "label": "Fort McPherson"},
    {"value": "Gameti", "label": "Gameti"},
    {"value": "Gjoa Haven", "label": "Gjoa Haven"},
    {"value": "Grise Fiord", "label": "Grise Fiord"},
    {"value": "Hall Beach", "label": "Hall Beach"},
    {"value": "Holman", "label": "Holman"},
    {"value": "Hopedale", "label": "Hopedale"},
    {"value": "Igloolik", "label": "Igloolik"},
    {"value": "Inukjuak", "label": "Inukjuak"},
    {"value": "Inuvik", "label": "Inuvik"},
    {"value": "Iqaluit", "label": "Iqaluit"},
    {"value": "Ivujivik", "label": "Ivujivik"},
    {"value": "Jean Marie River", "label": "Jean Marie River"},
    {"value": "Kangiqsualujjuaq", "label": "Kangiqsualujjuaq"},
    {"value": "Kangiqsujuaq", "label": "Kangiqsujuaq"},
    {"value": "Kangirsuk", "label": "Kangirsuk"},
    {"value": "Kawawachikamach", "label": "Kawawachikamach"},
    {"value": "Kimmirut", "label": "Kimmirut"},
    {"value": "Kugaaruk", "label": "Kugaaruk"},
    {"value": "Kugluktuk", "label": "Kugluktuk"},
    {"value": "Kuujjuaq", "label": "Kuujjuaq"},
    {"value": "Kuujjuaraapik", "label": "Kuujjuaraapik"},
    {"value": "Lutsel K'e", "label": "Lutsel K'e"},
    {"value": "Makkovik", "label": "Makkovik"},
    {"value": "Mittimatalik", "label": "Mittimatalik"},
    {"value": "Nain", "label": "Nain"},
    {"value": "Nanisivik", "label": "Nanisivik"},
    {"value": "Norman Wells", "label": "Norman Wells"},
    {"value": "Old Crow", "label": "Old Crow"},
    {"value": "Pangnirtung", "label": "Pangnirtung"},
    {"value": "Paulatuk", "label": "Paulatuk"},
    {"value": "Paulatuuq", "label": "Paulatuuq"},
    {"value": "Pelly Bay", "label": "Pelly Bay"},
    {"value": "Pond Inlet", "label": "Pond Inlet"},
    {"value": "Postville", "label": "Postville"},
    {"value": "Puvirnituq", "label": "Puvirnituq"},
    {"value": "Qausuittuq", "label": "Qausuittuq"},
    {"value": "Qikiqtarjuaq", "label": "Qikiqtarjuaq"},
    {"value": "Qiqiktarjuaq", "label": "Qiqiktarjuaq"},
    {"value": "Quaqtaq", "label": "Quaqtaq"},
    {"value": "Radisson", "label": "Radisson"},
    {"value": "Rankin Inlet", "label": "Rankin Inlet"},
    {"value": "Repulse Bay", "label": "Repulse Bay"},
    {"value": "Resolute", "label": "Resolute"},
    {"value": "Rigolet", "label": "Rigolet"},
    {"value": "Sachs Harbour", "label": "Sachs Harbour"},
    {"value": "Salluit", "label": "Salluit"},
    {"value": "Sanikiluaq", "label": "Sanikiluaq"},
    {"value": "Southern Tutchone", "label": "Southern Tutchone"},
    {"value": "Taloyoak", "label": "Taloyoak"},
    {"value": "Tasiujaq", "label": "Tasiujaq"},
    {"value": "Tlingit", "label": "Tlingit"},
    {"value": "Tsiigehtchic", "label": "Tsiigehtchic"},
    {"value": "Tuktoyaktuk", "label": "Tuktoyaktuk"},
    {"value": "Tulita", "label": "Tulita"},
    {"value": "Ulukhaktok", "label": "Ulukhaktok"},
    {"value": "Umiujaq", "label": "Umiujaq"},
    {"value": "Whale Cove", "label": "Whale Cove"},
    {"value": "Aboriginal land claim", "label": "Aboriginal land claim"},
    {"value": "Aboriginal organizations", "label": "Aboriginal organizations"},
    {"value": "Adaptation", "label": "Adaptation"},
    {"value": "Airports", "label": "Airports"},
    {"value": "Archaeology", "label": "Archaeology"},
    {"value": "Artifacts", "label": "Artifacts"},
    {"value": "Berry picking", "label": "Berry picking"},
    {"value": "Capacity building", "label": "Capacity building"},
    {"value": "Clam gathering", "label": "Clam gathering"},
    {"value": "Communication", "label": "Communication"},
    {"value": "Community freezer", "label": "Community freezer"},
    {"value": "Community infrastructure", "label": "Community infrastructure"},
    {"value": "Community mobilization", "label": "Community mobilization"},
    {"value": "Community vulnerability", "label": "Community vulnerability"},
    {"value": "Conservation", "label": "Conservation"},
    {"value": "Cooperation", "label": "Cooperation"},
    {"value": "Cultural development", "label": "Cultural development"},
    {"value": "Cultural landscape", "label": "Cultural landscape"},
    {"value": "Cultural preservation", "label": "Cultural preservation"},
    {"value": "Cultural values", "label": "Cultural values"},
    {"value": "Database (socioeconomic)", "label": "Database (socioeconomic)"},
    {"value": "Decision makers", "label": "Decision makers"},
    {"value": "Demography", "label": "Demography"},
    {"value": "Denesuline", "label": "Denesuline"},
    {"value": "Diabetes", "label": "Diabetes"},
    {"value": "Diplomacy", "label": "Diplomacy"},
    {"value": "Doctrines", "label": "Doctrines"},
    {"value": "Economic value", "label": "Economic value"},
    {"value": "Economics", "label": "Economics"},
    {"value": "Education", "label": "Education"},
    {"value": "Elders", "label": "Elders"},
    {"value": "Entrepreneurship", "label": "Entrepreneurship"},
    {"value": "Environment surveillance", "label": "Environment surveillance"},
    {"value": "Environmental health", "label": "Environmental health"},
    {"value": "Ethic", "label": "Ethic"},
    {"value": "Ethnography", "label": "Ethnography"},
    {"value": "Exposure", "label": "Exposure"},
    {"value": "Financial resources", "label": "Financial resources"},
    {"value": "Fishing", "label": "Fishing"},
    {"value": "Food security", "label": "Food security"},
    {"value": "Foreign policy", "label": "Foreign policy"},
    {"value": "Funding", "label": "Funding"},
    {"value": "Future exposure", "label": "Future exposure"},
    {"value": "Gender", "label": "Gender"},
    {"value": "Globalization", "label": "Globalization"},
    {"value": "Government", "label": "Government"},
    {"value": "Governmental policies", "label": "Governmental policies"},
    {"value": "Habitat vulnerability", "label": "Habitat vulnerability"},
    {"value": "Harvesting site", "label": "Harvesting site"},
    {"value": "Healing", "label": "Healing"},
    {"value": "Health promotion", "label": "Health promotion"},
    {"value": "Homelessness", "label": "Homelessness"},
    {"value": "Housing", "label": "Housing"},
    {"value": "Human adaptation", "label": "Human adaptation"},
    {"value": "Human health", "label": "Human health"},
    {"value": "Human occupation", "label": "Human occupation"},
    {"value": "Human perception", "label": "Human perception"},
    {"value": "Human remains", "label": "Human remains"},
    {"value": "Human resources", "label": "Human resources"},
    {"value": "Human rights", "label": "Human rights"},
    {"value": "Human-made hazards", "label": "Human-made hazards"},
    {"value": "Human-wildlife relationships", "label": "Human-wildlife relationships"},
    {"value": "Hunting", "label": "Hunting"},
    {"value": "Hunting location", "label": "Hunting location"},
    {"value": "Impact assessments", "label": "Impact assessments"},
    {"value": "Indigenous peoples", "label": "Indigenous peoples"},
    {"value": "Industries", "label": "Industries"},
    {"value": "Information sharing", "label": "Information sharing"},
    {"value": "International law", "label": "International law"},
    {"value": "International relations", "label": "International relations"},
    {"value": "Interview", "label": "Interview"},
    {"value": "Inuit entrepreneurship", "label": "Inuit entrepreneurship"},
    {"value": "Inuit Knowledge", "label": "Inuit Knowledge"},
    {"value": "Inuit population", "label": "Inuit population"},
    {"value": "Inuit Tapiriit Kanatami (ITK)", "label": "Inuit Tapiriit Kanatami (ITK)"},
    {"value": "Inuit Tuttarvingat (of NAHO)", "label": "Inuit Tuttarvingat (of NAHO)"},
    {"value": "James Bay and Northern Québec Agreement", "label": "James Bay and Northern Québec Agreement"},
    {"value": "Knowledge transfer", "label": "Knowledge transfer"},
    {"value": "Kwädāy Dän Ts¿ínchį", "label": "Kwädāy Dän Ts¿ínchį"},
    {"value": "Kyoto Protocol", "label": "Kyoto Protocol"},
    {"value": "Land claims", "label": "Land claims"},
    {"value": "Landuse", "label": "Landuse"},
    {"value": "Law", "label": "Law"},
    {"value": "Law of the Sea Convention", "label": "Law of the Sea Convention"},
    {"value": "Legacy", "label": "Legacy"},
    {"value": "Legal research", "label": "Legal research"},
    {"value": "Legal strategies", "label": "Legal strategies"},
    {"value": "Livelihood", "label": "Livelihood"},
    {"value": "Makivik Corporation", "label": "Makivik Corporation"},
    {"value": "Management", "label": "Management"},
    {"value": "Marine navigation", "label": "Marine navigation"},
    {"value": "Marine transport", "label": "Marine transport"},
    {"value": "Meteorological hazards", "label": "Meteorological hazards"},
    {"value": "Model", "label": "Model"},
    {"value": "Modernization", "label": "Modernization"},
    {"value": "Municipal authorities", "label": "Municipal authorities"},
    {"value": "National defence", "label": "National defence"},
    {"value": "Northerners", "label": "Northerners"},
    {"value": "Nunatsiavut Government", "label": "Nunatsiavut Government"},
    {"value": "Nunavut Government", "label": "Nunavut Government"},
    {"value": "Open-dialogue", "label": "Open-dialogue"},
    {"value": "Organizations", "label": "Organizations"},
    {"value": "Parks", "label": "Parks"},
    {"value": "Partnerships", "label": "Partnerships"},
    {"value": "Pilot projects", "label": "Pilot projects"},
    {"value": "Policy", "label": "Policy"},
    {"value": "Politics", "label": "Politics"},
    {"value": "Portage", "label": "Portage"},
    {"value": "Poverty", "label": "Poverty"},
    {"value": "Practical legislations", "label": "Practical legislations"},
    {"value": "Raglan Agreement", "label": "Raglan Agreement"},
    {"value": "Rail", "label": "Rail"},
    {"value": "Recreational hunting", "label": "Recreational hunting"},
    {"value": "Regional development", "label": "Regional development"},
    {"value": "Regional scale modeling", "label": "Regional scale modeling"},
    {"value": "Regulation", "label": "Regulation"},
    {"value": "Resilience", "label": "Resilience"},
    {"value": "Resource development", "label": "Resource development"},
    {"value": "Resource management strategies", "label": "Resource management strategies"},
    {"value": "Roads", "label": "Roads"},
    {"value": "Sanarrutik Agreement", "label": "Sanarrutik Agreement"},
    {"value": "Scenario", "label": "Scenario"},
    {"value": "Schools", "label": "Schools"},
    {"value": "Self-determination", "label": "Self-determination"},
    {"value": "Shipping", "label": "Shipping"},
    {"value": "Social benefits", "label": "Social benefits"},
    {"value": "Social change", "label": "Social change"},
    {"value": "Social cost", "label": "Social cost"},
    {"value": "Social impacts", "label": "Social impacts"},
    {"value": "Social integration", "label": "Social integration"},
    {"value": "Social sciences", "label": "Social sciences"},
    {"value": "Socio-economic impacts", "label": "Socio-economic impacts"},
    {"value": "Sovereignty", "label": "Sovereignty"},
    {"value": "Spirituality", "label": "Spirituality"},
    {"value": "Sport hunting", "label": "Sport hunting"},
    {"value": "Stakeholders", "label": "Stakeholders"},
    {"value": "Strategies", "label": "Strategies"},
    {"value": "Suicide", "label": "Suicide"},
    {"value": "Technological resources", "label": "Technological resources"},
    {"value": "Thule", "label": "Thule"},
    {"value": "Tourism", "label": "Tourism"},
    {"value": "Traditional Ecological Knowledge (TEK)", "label": "Traditional Ecological Knowledge (TEK)"},
    {"value": "Traditional economy", "label": "Traditional economy"},
    {"value": "Traditional Knowledge", "label": "Traditional Knowledge"},
    {"value": "Traditional language", "label": "Traditional language"},
    {"value": "Training", "label": "Training"},
    {"value": "Transportation", "label": "Transportation"},
    {"value": "Trappers", "label": "Trappers"},
    {"value": "Villages", "label": "Villages"},
    {"value": "Vocational education", "label": "Vocational education"},
    {"value": "Vulnerability", "label": "Vulnerability"},
    {"value": "Wage economy", "label": "Wage economy"},
    {"value": "Wellness", "label": "Wellness"},
    {"value": "Whaling", "label": "Whaling"},
    {"value": "Wooden artifacts", "label": "Wooden artifacts"},
    {"value": "Youth education", "label": "Youth education"},
    {"value": "Youth perspectives", "label": "Youth perspectives"},
    {"value": "Archive", "label": "Archive"},
    {"value": "Bibliography", "label": "Bibliography"},
    {"value": "Book", "label": "Book"},
    {"value": "Citizen science", "label": "Citizen science"},
    {"value": "Construction", "label": "Construction"},
    {"value": "CRYSYS", "label": "CRYSYS"},
    {"value": "Data centre", "label": "Data centre"},
    {"value": "Data portal", "label": "Data portal"},
    {"value": "Database (transdisciplinary)", "label": "Database (transdisciplinary)"},
    {"value": "Dredging", "label": "Dredging"},
    {"value": "guardians", "label": "guardians"},
    {"value": "Harvest", "label": "Harvest"},
    {"value": "Library", "label": "Library"},
    {"value": "Mining", "label": "Mining"},
    {"value": "Multidisciplinary", "label": "Multidisciplinary"},
    {"value": "Network", "label": "Network"},
    {"value": "Petroleum industry", "label": "Petroleum industry"},
    {"value": "Publication", "label": "Publication"},
    {"value": "Report", "label": "Report"},
    {"value": "Statistics (transdisciplinary)", "label": "Statistics (transdisciplinary)"},
    {"value": "Study", "label": "Study"},
    {"value": "Travelling", "label": "Travelling"},
    {"value": "Unmanned Aerial Vehicle (UAV)", "label": "Unmanned Aerial Vehicle (UAV)"}, 
  ];